import { cloneDeep } from 'lodash-es';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ɵcreateInjector as createInjector,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FilePricing } from '../../../../../../../../photographer-panel/src/graphql';
import {
  GetAvailablePrintsConfigGQL,
  PrintPriceConfig,
} from '../../../product-editor/graphql';
import {
  BehaviorSubject,
  Observable,
  ReplaySubject,
  Subject,
  combineLatest,
  filter,
  first,
  map,
  pluck,
  shareReplay,
  switchMap,
  takeUntil,
  tap,
  withLatestFrom,
} from 'rxjs';
import { TypedFormBuilder } from '../../../../form/TypedFormBuilder';
import { PriceConfig } from '../../../types';

import { ZalamoDialogService } from '../../../../zalamo-dialog/zalamo-dialog.service';
import { PrintDetailsComponent } from '../product-details/print-details/print-details.component';
import { select, Store } from '@ngrx/store';
import {
  addCalendarToBasket,
  addMagnetToBasket,
  addFileInBasketAction,
  addFileInPackageToBasketAction,
  addOneImageInPackageToBasketAction,
  addPackageToBasketAction,
  addPhotoToProductInBasket,
  addPrintInPackageToBasketAction,
  addPrintsListToBasketAction,
  addPrintToBasket,
  addProductInPackageToBasketAction,
  changePhotoToProductInBasket,
  changeRetouchInFileAction,
  deleteFileInBasketAction,
  deleteFileInPackageInBasketAction,
  deleteFilesAndPrintsInPackageInBasketAction,
  deletePhotoToProductInBasket,
  deletePrintAction,
  deletePrintInPackageInBasketAction,
} from '../../../shopping-cart-back/actions/actions';
import {
  CalendarForDisplay,
  MagnetForDisplay,
  Product,
} from '../../../../../../../../public-session/src/graphql';
import { ProductCardComponent } from '../product-card/product-card.component';
import {
  getFirstPrintFilePriceStepContext,
  Package,
  PackageInBasket,
  PhotoGroup,
  PhotoGroupHasPhoto,
  PhotoGroupList,
  PrintInBasket,
  RetouchLevel,
  ShoppingCartState,
} from '../../../shopping-cart-back/actions/standalone';
import {
  selectAllCost,
  selectAllProductsInBasket,
  selectCalcPrintsInPackage,
  selectCalendarInBasket,
  selectAllMagnetInBasket,
  selectConfigSell,
  selectDeliveryMethods,
  selectDoNotAddPriceOfFirstPrint,
  selectFilePrices,
  selectFilesInBasket,
  selectFreePackage,
  selectLookBookProductsInBasket,
  selectPackagesInBasket,
  selectPackagesInShop,
  selectPhotoById,
  selectPhotoGroups,
  selectPhotoGroupsHasPhoto,
  selectPhotosList,
  selectPriceToAddToEveryFileInLookBookProduct,
  selectPriceToAddToEveryFileInProduct,
  selectPriceToAddToFirstPrint,
  selectPrintPrices,
  selectPrintsInBasket,
  selectProductsInBasket,
  selectProductsList,
  selectRetouchLevels,
  selectSettingPhotoGroup,
  selectShoppingCartContext,
  selectShoppingCartId,
  selectUsePromoCodes,
  selectWasProposedPackageWithPhotos,
} from '../../../shopping-cart-back/actions/selector';
import { SwapPhotoInTheProductComponent } from '../swap-photo-in-the-product/swap-photo-in-the-product.component';
import { PreviewProductInBasketComponent } from '../preview-product-in-basket/preview-product-in-basket.component';
import { SinglePhotoProductOptionsService } from './single-photo-product-options.service';
import { ZalamoTooltipService } from '../../../../zalamo-tooltip/zalamo-tooltip.service';
import { TooltipRef } from '../../../../zalamo-tooltip/tooltip-ref';
import { ChangeNumberComponent } from '../../../../change-number/change-number.component';

import { AliveState } from '../../../../../core/ActiveState';
import { UntypedFormControl } from '@angular/forms';
import { getMagnetOffers } from './magnet-offers';
import { calculateZalamoMagnetAutoCrop } from '@ui/zalamo-print-ordering/zalamo-magnet-crop';
import { PackagesListComponent } from '../packages-list/packages-list.component';
import { ZalamoObject } from '../../../../../zalamo/pipes/names/graphql';
import { singleStepPriceCalculator } from '../../../../step-pricing/StepPriceCalculator';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MessageAboutFreePackageComponent } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/message-about-free-package/message-about-free-package.component';
import { ViewPackageComponent } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/view-package/view-package.component';
import { SuggestPackageAtBeginningService } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/view-package/suggest-package-at-beginning.service';
import { CheckingForMatchingPhotosInProductService } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/view-product-in-package/checking-for-matching-photos-in-product.service';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { AutoAddFileToBasketTogetherWithProductService } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/product-card/auto-add-file-to-basket-together-with-product.service';
import { FullscreenService } from 'ZalamoLibrary/src/lib/ui/fullscreen/fullscreen.service';
import { AutoAddFileToBasketTogetherWithPrintInPackageServiceService } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/edition-print-in-basket/auto-add-file-to-basket-together-with-print-in-package-service.service';
import { singlePrintStepPriceCalculator } from 'ZalamoLibrary/src/lib/ui/print-step-pricing/print-step-price-calculator';
import { findAllPrintsInBasket } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/calc-price-all-prints-in-basket/calc-price-all-prints-in-basket';
import cuid from 'cuid';
import { PublicSessionWallDecorEditorComponent } from '@ui/products/products-front/components/public-session-wall-decor-editor/public-session-wall-decor-editor.component';
import { WallDecorPieceForDisplayType } from '@ui/look-book-front/wall-decor-front/graphql';
import { GetImageUrlService } from 'ZalamoLibrary/src/lib/core/image/image-loader/get-image-url.service';
import { FaceDetectorService } from 'ZalamoLibrary/src/lib/zalamo/face-detection/face-detector.service';
import { translationProvider } from '@ui/nls/translations/translate.directive';
import { TranslationLoaderService } from '@ui/nls/translations/translation-loader.service';
import { firstValueFrom } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';

export function findAndSelectFileInOnePhoto(
  filePrices,
  filesInBasket,
  photoId,
) {
  return filePrices.map((file) => ({
    isFull: file.isFull,
    size: file.size,
    price: file.stepPricingEnabled
      ? singleStepPriceCalculator(
          filesInBasket.find((x) => x.photoId === photoId)
            ? filesInBasket.filter(
                (x) => x.filePricingId === file.filePricingId,
              ).length
            : filesInBasket.filter(
                (x) => x.filePricingId === file.filePricingId,
              ).length + 1,
          filesInBasket.filter((x) => x.filePricingId === file.filePricingId)
            .length + 1,
          file.stepPricing,
          file.price,
        )
      : file.price,
    filePricingId: file.filePricingId,
    onlyPackage: false,
    inPackage: false,
    inBasket: false,
    inPackageOrInBasket: false,
    freeSpaceInPackage: 0,
    togetherWithPrint: false,
  }));
}

export function checkingIfImagesAreRequired(
  productsInShop,
  productId: string,
  configuration,
): { imagesRequired: boolean; requiredImages: { min: number; max: number } } {
  const images = {
    imagesRequired: false,
    requiredImages: { min: 0, max: 0 },
  };
  if (
    productsInShop.find((value) => value.productId === productId).imagesRequired
  ) {
    images.imagesRequired = true;
    images.requiredImages = productsInShop.find(
      (value) => value.productId === productId,
    ).requiredImages;
  }
  const config = productsInShop
    .find((p) => p.productId === productId)
    .config.filter(({ type }) => ['list', 'size', 'decoration'].includes(type))
    .reverse()
    .find(({ customId, options }) =>
      options?.find(
        ({ configId }) =>
          configId ===
          configuration.find((value) => value[0] === customId)?.[1],
      ),
    );
  const option = config?.options.find(
    ({ configId }) =>
      configId ===
      configuration.find((value) => value[0] === config.customId)?.[1],
  );
  if (option && option.hasRequiredImagesModifier) {
    images.imagesRequired = option.hasRequiredImagesModifier;
    images.requiredImages = option.requiredImagesModifier;
  }
  return images;
}

export interface VisiblePrint {
  maxNumber: number;
  minNumber: number;
  printPaperId: string;
  printFormatId: string;
  price: Array<PriceConfig>;
  onlyPackage: boolean;
  inPackage: boolean;
  countInBasket: number;
  countInPackage: number;
  togetherWithFile: boolean;
  countInTogetherWithFile: number;
  countInPackageInBasket: number;
  printPhoto: number;
}

export interface PrintInPackage {
  countInPackage: number;
  countInBasket: number;
  printFormatId: string;
  printPaperId: string;
  printAndFileConfigId: string;
  packageInBasketId: string;
  mode: string;
  addFileToPrintInPackage: boolean;
}

export interface VisibleFile {
  isFull: boolean;
  size: number;
  filePricingId?: string;
  price: Array<PriceConfig>;
  onlyPackage: boolean;
  inPackage: boolean;
  freeSpaceInPackage: number;
  inBasket: boolean;
  inPackageOrInBasket: boolean;
  togetherWithPrint: boolean;
}

export interface ProductsInPacketInBasket {
  products: Array<{
    count: number;
    nameClientProduct: string;
    productId: string;
    packageId: string;
    productInPackageId: string;
    selectedProductId: string;
    photos: Array<{ photoId: string }>;
    config: string;
    photosSelectedByPhotographer: {
      mode: string;
      photos: Array<{ photoId: string }>;
    };
    customName: Array<{
      language: string;
      text: string;
    }>;
    max: boolean;
    thisPhotoIsAdd: boolean;
  }>;
  name: string;
  packageInBasketId: string;
}

export interface ProductsInPacket {
  products: Array<{
    packageId: string;
    productInPackageId: string;
    productId: string;
    photosSelectedByPhotographer: {
      mode: string;
      photos: Array<{ photoId: string }>;
    };
    customName: Array<{
      language: string;
      text: string;
    }>;
    config: string;
    qty: number;
  }>;
  name: string;
  packageInBasketId: string;
}

@Component({
  selector: 'lib-single-photo-product-options',
  templateUrl: './single-photo-product-options.component.html',
  styleUrls: ['./single-photo-product-options.component.scss'],
  providers: [translationProvider('productFront')],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SinglePhotoProductOptionsComponent
  extends AliveState
  implements OnInit
{
  currentPhotoId$ = new ReplaySubject<string>(1);
  tambourProductType = WallDecorPieceForDisplayType.Tambour;
  zalamoCalendarProductType = WallDecorPieceForDisplayType.ZalamoCalendar;

  get photoId(): string {
    return this._photoId;
  }

  @Input() set photoId(value: string) {
    this._photoId = value;
    this.currentPhotoId$.next(value);
  }

  photoRatio$ = this.currentPhotoId$.pipe(
    switchMap((photoId) => this.store.pipe(select(selectPhotoById(photoId)))),
    map((photo) => photo.width / photo.height),
  );

  @Input() sellPrintFrames = false;
  calendarUpdateInProgress = false;
  faces$ = this.currentPhotoId$.pipe(
    switchMap(() =>
      this.store.select(selectPhotoById(this.photoId)).pipe(
        switchMap((photo) => {
          return this.downloader.transform(
            { photoId: this.photoId },
            photo.photoGroupId,
            'anyone',
            this.context,
            this.contextId,
            200,
          );
        }),
        switchMap((url) => {
          const start = Date.now();

          return combineLatest([
            this.faceDetectorService.detectFaces(
              String(url).match(/blob:(.*?) /)[0],
            ),
            this.photoRatio$,
          ]).pipe(
            map(([{ faces, gravityCenter }, ratio]) => ({
              faces,
              gravityCenter,
              maxSquare:
                faces.length === 0
                  ? {}
                  : ((gravityCenter) => {
                      const xCenter =
                        gravityCenter[0] +
                        (gravityCenter[2] - gravityCenter[0]) / 2;
                      const yCenter =
                        gravityCenter[1] +
                        (gravityCenter[3] - gravityCenter[1]) / 2;
                      const imageWidth = 100;
                      const imageHeight = imageWidth / ratio;
                      const result = [
                        xCenter * imageWidth - 1,
                        yCenter * imageHeight - 1,
                        xCenter * imageWidth + 1,
                        yCenter * imageHeight + 1,
                      ];
                      while (
                        result[0] > 0 &&
                        result[1] > 0 &&
                        result[2] < imageWidth &&
                        result[3] < imageHeight
                      ) {
                        result[0] -= 1;
                        result[1] -= faces.length === 1 ? 0.7 : 0.85;
                        result[2] += 1;
                        result[3] += faces.length === 1 ? 1.3 : 1.15;
                      }
                      return {
                        x: Math.abs(result[0] / imageWidth) * 100,
                        y: Math.abs(result[1] / imageHeight) * 100,
                        w: ((result[2] - result[0]) / imageWidth) * 100,
                        h: ((result[3] - result[1]) / imageHeight) * 100,
                      };
                    })(gravityCenter),
              url,
              end: Date.now() - start,
            })),
          );
        }),
        shareReplay(1),
      ),
    ),
  );
  private _photoId: string;
  @Input() sellLookBookWallDecor = false;
  @Input() sellZalamoCalendar = false;
  @Input() calendarPrices: CalendarForDisplay[] = [];
  @Input() sellZalamoMagnet = false;
  private readonly magnetPrices$ = new BehaviorSubject<MagnetForDisplay[]>([]);
  @Input() set magnetPrices(value: MagnetForDisplay[]) {
    this.magnetPrices$.next(value ?? []);
  }
  readonly magnetCountChanges$ = new Subject<{
    sizeId: string;
    count: number;
  }>();
  readonly magnetOffers$ = combineLatest([
    this.magnetPrices$,
    this.store.pipe(select(selectAllMagnetInBasket)),
    this.currentPhotoId$,
  ]).pipe(
    map(([pricing, basket, photoId]) =>
      getMagnetOffers(pricing, basket, photoId),
    ),
  );
  readonly trackMagnetOffer = (_: number, offer: { sizeId: string }): string =>
    offer.sizeId;
  @Input() sellLookBookTambour = false;
  @Input() disablePersonalizationOnSinglePhotoWallDecor = false;
  @Input() disablePersonalizationOnSinglePhotoTambour = false;
  @Output() closeDialog = new EventEmitter();
  @Output() closeAllDialog = new EventEmitter();
  @Output() goToPackageMenu = new EventEmitter();
  @Input() @Required context: ZalamoObject;
  @Input() @Required contextId: string;
  tooltipRef: TooltipRef<any> = null;
  closeOpenedDialog = false;
  calendarInBasket = new UntypedFormControl(0);
  calendarThumbInBasket = new UntypedFormControl(0);
  calendarCropInBasket = new UntypedFormControl(0);
  printsPricing$ = new BehaviorSubject([]);
  productsInBasket$ = this.store.pipe(select(selectProductsInBasket));
  productsInShop$ = this.store.pipe(select(selectProductsList));
  packagesInBasket$ = this.store.pipe(select(selectPackagesInBasket));
  packagesInShop$ = this.store.pipe(select(selectPackagesInShop));
  photoGroupsHasPhoto$ = this.store.pipe(select(selectPhotoGroupsHasPhoto));
  prints$ = this.store.pipe(select(selectPrintPrices));
  printsInBasket$ = this.store.pipe(select(selectPrintsInBasket));
  filesInBasket$ = this.store.pipe(select(selectFilesInBasket));
  photosList$ = this.store.pipe(select(selectPhotosList));
  photoGroups$ = this.store.pipe(select(selectPhotoGroups));
  allProductsInBasket$ = this.store.pipe(select(selectAllProductsInBasket));
  filePrices$ = this.store.pipe(select(selectFilePrices));
  shoppingCartId$ = this.store.pipe(select(selectShoppingCartId));
  deliveryMethods$ = this.store.pipe(select(selectDeliveryMethods));
  usePromoCodes$ = this.store.pipe(select(selectUsePromoCodes));
  freePackage$ = this.store.pipe(select(selectFreePackage));
  priceToAddToFirstPrint$ = this.store.pipe(
    select(selectPriceToAddToFirstPrint),
  );
  priceToAddToEveryFileInProduct$ = this.store.pipe(
    select(selectPriceToAddToEveryFileInProduct),
  );
  wasProposedPackageWithPhotos$ = this.store.pipe(
    select(selectWasProposedPackageWithPhotos),
  );
  currentBasketValue$ = this.store
    .select(selectAllCost)
    .pipe(pluck('afterDiscount'));
  configSell$ = this.store.pipe(select(selectConfigSell));
  lookbBookDisabledByGroup$ = combineLatest([
    this.photoGroups$,
    this.photosList$,
  ]).pipe(
    map(([photoGroups, photosList]) => {
      const individualConfig = photoGroups.find(
        (value2) =>
          value2.photoGroupId ===
          photosList
            .find(({ photos }) =>
              photos.find(({ photoId }) => photoId === this._photoId),
            )
            .photos.find(({ photoId }) => photoId === this._photoId)
            ?.photoGroupId,
      )?.config;

      return individualConfig?.disableLookBook;
    }),
  );
  visibleProducts$ = combineLatest([
    this.productsInShop$,
    this.configSell$,
    this.photoGroups$,
    this.photosList$,
  ]).pipe(
    map(([product, configSell, photoGroups, photosList]) => {
      const individualConfig = photoGroups.find(
        (value2) =>
          value2.photoGroupId ===
          photosList
            .find(({ photos }) =>
              photos.find(({ photoId }) => photoId === this._photoId),
            )
            .photos.find(({ photoId }) => photoId === this._photoId)
            ?.photoGroupId,
      )?.config;
      if (
        (individualConfig.individualSellSettings &&
          ((individualConfig.sellProducts &&
            !individualConfig.customProductsConfig &&
            configSell.sellProducts) ||
            (individualConfig.sellProducts &&
              individualConfig.customProductsConfig))) ||
        (!individualConfig.individualSellSettings && configSell.sellProducts)
      ) {
        const visibleProduct = [];
        product
          .filter(({ productId }) =>
            individualConfig.customProductsConfig
              ? !individualConfig.excludedProducts?.includes(productId)
              : !configSell.excludedProducts?.includes(productId),
          )
          .forEach((value) => {
            if (value.imagesRequired === true) {
              visibleProduct.push(value);
            }
          });
        return visibleProduct;
      }
      return [];
    }),
    shareReplay(),
  );
  productInPackageInBasket$: Observable<Array<ProductsInPacketInBasket>> =
    combineLatest([
      this.packagesInShop$,
      this.packagesInBasket$,
      this.productsInShop$,
      this.photoGroupsHasPhoto$,
      this.visibleProducts$,
    ]).pipe(
      map(
        ([
          packagesInShop,
          packagesInBasket,
          productsInShop,
          photosList,
          visibleProducts,
        ]) => {
          let productInPackage: Array<ProductsInPacketInBasket> = [];
          const visibleProductIds = visibleProducts.map(
            ({ productId }) => productId,
          );
          packagesInBasket?.forEach(
            ({ product, packageInBasketId, packageId, file, print }) => {
              productInPackage.push({
                name: packagesInShop.package.find(
                  (x) => x.packageId === packageId,
                ).name,
                packageInBasketId,
                products: product
                  .filter(
                    ({ productInPackageId, productId }) =>
                      visibleProductIds.includes(productId) &&
                      productsInShop.find((x) => x.productId === productId)
                        .imagesRequired &&
                      (packagesInShop.package
                        .find((x) => x.packageId === packageId)
                        .productConfig.find(
                          (x) => x.productInPackageId === productInPackageId,
                        ).mode === 'AnyImages' ||
                        (this.countingPossibleNumberOfPhotosInProduct(
                          file,
                          print,
                        ).length >
                          productsInShop.find((x) => x.productId === productId)
                            .requiredImages.max &&
                          this.countingPossibleNumberOfPhotosInProduct(
                            file,
                            print,
                          ).find(({ photoId }) => photoId === this._photoId))),
                  )
                  .map((pro) => ({
                    count: pro.count,
                    nameClientProduct: pro.nameClientProduct,
                    productId: pro.productId,
                    packageId,
                    productInPackageId: pro.productInPackageId,
                    selectedProductId: pro.selectedProductId,
                    photos: pro.photos,
                    customName: packagesInShop.package
                      .find((x) => x.packageId === packageId)
                      .productConfig.find(
                        ({ productInPackageId }) =>
                          productInPackageId === pro.productInPackageId,
                      ).customName,
                    config: JSON.stringify(pro.config),
                    photosSelectedByPhotographer: {
                      mode: packagesInShop.package
                        .find((x) => x.packageId === packageId)
                        .productConfig.find(
                          ({ productInPackageId }) =>
                            productInPackageId === pro.productInPackageId,
                        ).mode,
                      photos:
                        packagesInShop.package
                          .find((x) => x.packageId === packageId)
                          .productConfig.find(
                            ({ productInPackageId }) =>
                              productInPackageId === pro.productInPackageId,
                          ).mode === 'AnyImages'
                          ? photosList.map(({ photoId }) => ({ photoId }))
                          : this.countingPossibleNumberOfPhotosInProduct(
                              file,
                              print,
                            ),
                    },
                    thisPhotoIsAdd: !!pro.photos.find(
                      ({ photoId }) => photoId === this._photoId,
                    ),
                    max:
                      checkingIfImagesAreRequired(
                        productsInShop,
                        pro.productId,
                        pro.config,
                      ).requiredImages.max === pro.photos.length,
                  })),
              });
            },
          );
          productInPackage = productInPackage.filter(
            ({ products }) => products.length > 0,
          );
          // console.table(productInPackage);
          return productInPackage;
        },
      ),
    );

  productInPackage$: Observable<Array<ProductsInPacket>> = combineLatest([
    this.packagesInShop$,
    this.packagesInBasket$,
    this.photoGroupsHasPhoto$,
    this.productsInShop$,
  ]).pipe(
    map(
      ([
        packagesInShop,
        packagesInBasket,
        photoGroupsHasPhoto,
        productsInShop,
      ]) => {
        let current: Array<ProductsInPacket> = [];
        packagesInBasket.forEach((packageInBasket) => {
          current.push({
            name: packagesInShop.package.find(
              ({ packageId }) => packageInBasket.packageId,
            ).name,
            packageInBasketId: packageInBasket.packageInBasketId,
            products: packagesInShop.package
              .find(({ packageId }) => packageId === packageInBasket.packageId)
              .productConfig.filter(
                ({ productId, mode }) =>
                  productsInShop.find((x) => x.productId === productId)
                    .imagesRequired &&
                  (mode === 'AnyImages' ||
                    (mode === 'AllImagesFromPackage' &&
                      this.countingPossibleNumberOfPhotosInProduct(
                        packageInBasket.file,
                        packageInBasket.print,
                      ).length >
                        productsInShop.find((x) => x.productId === productId)
                          .requiredImages.max &&
                      this.countingPossibleNumberOfPhotosInProduct(
                        packageInBasket.file,
                        packageInBasket.print,
                      ))),
              )
              .map(
                ({
                  mode,
                  customName,
                  qty,
                  productInPackageId,
                  config,
                  productId,
                }) => ({
                  productId,
                  config,
                  productInPackageId,
                  qty,
                  packageId: packageInBasket.packageId,
                  photosSelectedByPhotographer: {
                    mode,
                    photos:
                      mode === 'AllImagesFromPackage'
                        ? this.countingPossibleNumberOfPhotosInProduct(
                            packageInBasket.file,
                            packageInBasket.print,
                          )
                        : photoGroupsHasPhoto.map(({ photoId }) => ({
                            photoId,
                          })),
                  },
                  customName,
                }),
              ),
          });
          packageInBasket.product.forEach(({ productInPackageId }) => {
            if (
              current[current.length - 1].products.find(
                (x) => x.productInPackageId === productInPackageId,
              )
            ) {
              current[current.length - 1].products.splice(
                current[current.length - 1].products.findIndex(
                  (x) => x.productInPackageId === productInPackageId,
                ),
                1,
              );
            }
          });
        });
        current = current.filter(({ products }) => products.length > 0);
        console.table(current);
        return current;
      },
    ),
  );
  model = this.fb.group({});
  oldModel = { first: false, old: {} };
  @Input() filesPricing: Array<FilePricing> = [];
  visibleFiles: Array<VisibleFile> = [];
  @Input() printsPricing: Array<PrintPriceConfig> = [];
  @Input() onlyOneGroup = 'global';
  @Input() addPrintFileToBasketIfNotAlreadyBought = false;
  @Input() addToFirstPrintPrice = false;
  visibleFiles$: Observable<Array<VisibleFile>> = combineLatest([
    combineLatest([
      this.filesInBasket$,
      this.packagesInBasket$,
      this.packagesInShop$,
      this.photoGroupsHasPhoto$,
      this.printsInBasket$,
    ]),
    combineLatest([
      this.photosList$,
      this.store.pipe(select(selectProductsInBasket)),
      this.store.pipe(select(selectPriceToAddToEveryFileInProduct)),
      this.store.pipe(select(selectPhotoGroups)),
    ]),
    combineLatest([
      this.store.pipe(select(selectFilePrices)),
      this.store.pipe(select(selectPriceToAddToFirstPrint)),
    ]),
  ]).pipe(
    map(
      ([
        [
          filesInBasket,
          packagesInBasket,
          packagesInShop,
          photoGroupsHasPhoto,
          printsInBasket,
        ],
        [
          photosList,
          productsInBasket,
          priceToAddToEveryFileInProduct,
          photoGroups,
        ],
        [filePrices, standardPriceToAddToFirstPrint],
      ]) => {
        let visibleFiles: Array<VisibleFile> = this.filesPricing.map(
          ({
            filePricingId,
            price,
            size,
            isFull,
            stepPricingEnabled,
            stepPricing,
          }) => {
            const filePriceStepContext = getFirstPrintFilePriceStepContext({
              photoGroups,
              photoGroupList: photosList,
              priceToAddToFirstPrint: standardPriceToAddToFirstPrint,
              priceToAddToEveryFileInProduct,
              filePrices,
              printsInBasket,
              filesInBasket,
              productsInBasket,
              packagesInBasket,
              candidate: {
                photoId: this._photoId,
                filePricingId,
                type: 'file',
              },
            });
            return {
              isFull,
              size,
              filePricingId,
              price:
                stepPricingEnabled && filePriceStepContext
                  ? singleStepPriceCalculator(
                      filePriceStepContext.index,
                      filePriceStepContext.total,
                      stepPricing,
                      price,
                    )
                  : price,
              onlyPackage: false,
              inPackage: false,
              freeSpaceInPackage: 0,
              inBasket: false,
              inPackageOrInBasket: false,
              togetherWithPrint: false,
              togetherWithProduct: false,
            };
          },
        );
        packagesInBasket?.forEach((packageInBasket) => {
          packagesInShop.package
            .find(({ packageId }) => packageId === packageInBasket.packageId)
            .printAndFileConfig.forEach(
              ({ groups, filesConfig, forcedImage, mode }) => {
                if (
                  (mode !== 'PickedImage' &&
                    groups.find(
                      (group) =>
                        group ===
                        photoGroupsHasPhoto.find(
                          ({ photoId }) => photoId === this._photoId,
                        ).photoGroupId,
                    )) ||
                  forcedImage?.photoId === this._photoId
                ) {
                  filesConfig.forEach(({ count, isFull, size }) => {
                    const currentFile = visibleFiles.find(
                      (v) => v.isFull === isFull && v.size === size,
                    );
                    if (currentFile) {
                      currentFile.inPackage = true;
                      currentFile.freeSpaceInPackage += count;
                    } else {
                      visibleFiles.push({
                        isFull,
                        size,
                        price: [],
                        onlyPackage: true,
                        inPackage: true,
                        inBasket: false,
                        inPackageOrInBasket: false,
                        freeSpaceInPackage: count,
                        togetherWithPrint: false,
                      });
                    }
                  });
                }
              },
            );
          const fileInPackage = packageInBasket.file.find(
            ({ photoId }) => photoId === this._photoId,
          );
          if (fileInPackage) {
            visibleFiles.find(
              (v) =>
                v.isFull === fileInPackage.isFull &&
                v.size === fileInPackage.size,
            ).inPackageOrInBasket = true;
          }
          packageInBasket.file
            .filter(({ photoId }) =>
              packagesInShop.package.find(({ printAndFileConfig }) =>
                printAndFileConfig.find(
                  ({ groups, mode, forcedImage }) =>
                    (groups.find(
                      (groupId) =>
                        groupId ===
                        photoGroupsHasPhoto.find(
                          (p) => p.photoId === this._photoId,
                        ).photoGroupId,
                    ) &&
                      groups.find(
                        (groupId) =>
                          groupId ===
                          photoGroupsHasPhoto.find((p) => p.photoId === photoId)
                            .photoGroupId,
                      )) ||
                    (mode === 'PickedImage' &&
                      forcedImage.photoId === this._photoId),
                ),
              ),
            )
            .forEach((file) => {
              if (
                packagesInShop.package
                  .find(({ printAndFileConfig }) =>
                    printAndFileConfig.find(
                      ({ printAndFileConfigId }) =>
                        printAndFileConfigId === file.printAndFileConfigId,
                    ),
                  )
                  ?.printAndFileConfig.find(
                    ({ printAndFileConfigId }) =>
                      printAndFileConfigId === file.printAndFileConfigId,
                  ).mode !== 'PickedImage' ||
                packagesInShop.package
                  .find(({ printAndFileConfig }) =>
                    printAndFileConfig.find(
                      ({ printAndFileConfigId }) =>
                        printAndFileConfigId === file.printAndFileConfigId,
                    ),
                  )
                  .printAndFileConfig.find(
                    ({ printAndFileConfigId }) =>
                      printAndFileConfigId === file.printAndFileConfigId,
                  ).forcedImage.photoId === this._photoId
              ) {
                visibleFiles.find(
                  (v) => v.isFull === file.isFull && v.size === file.size,
                ).freeSpaceInPackage -= 1;
              }
            });
          packageInBasket.print
            .filter(({ photoId }) =>
              packagesInShop.package.find(({ printAndFileConfig }) =>
                printAndFileConfig.find(
                  ({ groups, mode, forcedImage }) =>
                    groups.find(
                      (groupId) =>
                        groupId ===
                        photoGroupsHasPhoto.find(
                          (p) => p.photoId === this._photoId,
                        ).photoGroupId,
                    ) ||
                    (mode === 'PickedImage' &&
                      forcedImage.photoId === this._photoId),
                ),
              ),
            )
            .forEach((print) => {
              if (
                !packageInBasket.file.find(
                  ({ photoId, printAndFileConfigId }) =>
                    photoId === print.photoId &&
                    printAndFileConfigId === print.printAndFileConfigId,
                ) &&
                packageInBasket.print.find(
                  ({ printAndFileConfigId }) =>
                    printAndFileConfigId === print.printAndFileConfigId,
                ) &&
                packagesInShop.package
                  .find(({ printAndFileConfig }) =>
                    printAndFileConfig.find(
                      ({ printAndFileConfigId }) =>
                        printAndFileConfigId === print.printAndFileConfigId,
                    ),
                  )
                  ?.printAndFileConfig.find(
                    ({ printAndFileConfigId }) =>
                      printAndFileConfigId === print.printAndFileConfigId,
                  ).mode === 'OneImage'
              ) {
                const file = packagesInShop.package
                  .find(({ printAndFileConfig }) =>
                    printAndFileConfig.find(
                      ({ printAndFileConfigId }) =>
                        printAndFileConfigId === print.printAndFileConfigId,
                    ),
                  )
                  ?.printAndFileConfig.find(
                    ({ printAndFileConfigId }) =>
                      printAndFileConfigId === print.printAndFileConfigId,
                  )?.filesConfig[0];
                if (file) {
                  visibleFiles.find(
                    (v) => v.isFull === file.isFull && v.size === file.size,
                  ).freeSpaceInPackage -= 1;
                }
              }
            });
        });
        const fileInBasket = filesInBasket.find(
          ({ photoId }) => photoId === this._photoId,
        );
        if (
          fileInBasket &&
          visibleFiles.find(
            (v) =>
              v.isFull === fileInBasket.isFull && v.size === fileInBasket.size,
          )
        ) {
          const visibleFile = visibleFiles.find(
            (v) =>
              v.isFull === fileInBasket.isFull && v.size === fileInBasket.size,
          );
          visibleFile.inPackageOrInBasket = true;
          visibleFile.inBasket = true;
          visibleFile.togetherWithPrint = fileInBasket?.togetherWithPrint
            ? fileInBasket.togetherWithPrint
            : false;
        } else if (fileInBasket) {
          visibleFiles.push({
            size: fileInBasket.size,
            inBasket: true,
            inPackageOrInBasket: true,
            inPackage: false,
            filePricingId: fileInBasket.filePricingId,
            price: [],
            onlyPackage: false,
            isFull: fileInBasket.isFull,
            freeSpaceInPackage: 0,
            togetherWithPrint: fileInBasket?.togetherWithPrint
              ? fileInBasket.togetherWithPrint
              : false,
          });
        }
        const patch = cloneDeep(
          visibleFiles
            .map(({ inPackageOrInBasket, size }) => ({
              inPackageOrInBasket,
              size,
            }))
            .reduce(
              (obj, { size, inPackageOrInBasket }) => ({
                ...obj,
                [size]: inPackageOrInBasket,
              }),
              {},
            ),
        );
        if (
          visibleFiles.length &&
          JSON.stringify(this.model.value) !== JSON.stringify(patch)
        ) {
          Object.keys(patch).forEach((patchKey) => {
            this.model.addControl(patchKey, new UntypedFormControl());
          });
          this.oldModel.old = patch;
          this.model.setValue(patch);
        }
        if (
          visibleFiles.find(
            ({ inPackageOrInBasket }) => !!inPackageOrInBasket,
          ) &&
          (filesInBasket.find(
            ({ photoId, togetherWithProduct, togetherWithPrint }) =>
              photoId === this._photoId &&
              (togetherWithProduct || togetherWithPrint),
          ) ||
            (this.addPrintFileToBasketIfNotAlreadyBought &&
              ((!this.addToFirstPrintPrice &&
                printsInBasket.find(
                  (p) => !p?.togetherWithFile && p?.photoId === this._photoId,
                ) &&
                !printsInBasket.find(
                  (p) => p?.togetherWithFile && p?.photoId === this._photoId,
                )) ||
                (this.addToFirstPrintPrice &&
                  printsInBasket.find(
                    (p) =>
                      p?.timeAddedToShoppingCart <
                        filesInBasket.find(
                          ({ photoId }) => photoId === this._photoId,
                        )?.timeAddedToShoppingCart &&
                      !p?.togetherWithFile &&
                      p?.photoId === this._photoId,
                  )))))
        ) {
          visibleFiles = [
            ...visibleFiles.map((value) => ({ ...value, price: [] })),
          ];
        }
        this.visibleFiles = visibleFiles;
        // console.table(visibleFiles);
        return visibleFiles;
      },
      shareReplay(1),
    ),
  );
  retouchLevels$: Observable<Array<RetouchLevel & { selected: boolean }>> =
    combineLatest([
      this.visibleFiles$,
      this.filesInBasket$,
      this.store.select(selectRetouchLevels),
    ]).pipe(
      map(([visibleFiles, filesInBasket, retouchLevels]) => {
        const retouch = !!visibleFiles.find(({ inBasket }) => !!inBasket)?.price
          ? retouchLevels?.map((value) => ({
              ...value,
              selected:
                filesInBasket.find(({ photoId }) => photoId === this._photoId)
                  ?.retouchLevelId === value.retouchLevelId,
            }))
          : [];
        if (!!retouch.length) {
          retouch.unshift({
            retouchLevelId: 'standard',
            price: retouch[0].price.map(({ code }) => ({ price: 0, code })),
            label: [{ language: 'pl', text: 'Standard' }],
            selected:
              filesInBasket.find(({ photoId }) => photoId === this._photoId)
                ?.retouchLevelId === 'standard',
          });
        }
        return retouch;
      }),
    );
  visiblePrints$: Observable<Array<VisiblePrint>> = combineLatest([
    this.printsInBasket$,
    this.packagesInShop$,
    this.packagesInBasket$,
    this.photoGroupsHasPhoto$,
    this.photosList$,
    this.photoGroups$,
    this.store.pipe(select(selectCalcPrintsInPackage)),
  ]).pipe(
    map<
      [
        PrintInBasket[],
        { package: Package[]; onePackage: boolean },
        PackageInBasket[],
        PhotoGroupHasPhoto[],
        PhotoGroupList[],
        PhotoGroup[],
        boolean,
      ],
      Array<VisiblePrint>
    >(
      ([
        printsInBasket,
        packagesInShop,
        packagesInBasket,
        photoGroupsHasPhoto,
        photosList,
        photoGroups,
        calcPrintsInPackage,
      ]) => {
        const printPricing = findAllPrintsInBasket(
          printsInBasket,
          photosList,
          photoGroups,
          calcPrintsInPackage,
          packagesInBasket,
        );
        const visiblePrints = this.printsPricing.map(
          ({
            price,
            printFormatId,
            printPaperId,
            stepPricingEnabled,
            stepPricing,
          }) => {
            const count = printPricing
              .find(
                (x) =>
                  x.printPaperId === printPaperId &&
                  x.printFormatId === printFormatId &&
                  x.photoGroupId === this.onlyOneGroup,
              )
              ?.prints.reduce((current, two) => current + two.count, 0);
            const nextPrice =
              stepPricingEnabled && stepPricing
                ? singlePrintStepPriceCalculator(
                    (count ? count : 0) + 1,
                    stepPricing,
                    price,
                  )
                : price;
            return {
              maxNumber: 999,
              minNumber: 0,
              printPaperId,
              printFormatId,
              price: nextPrice,
              onlyPackage: false,
              inPackage: false,
              togetherWithFile: false,
              countInBasket: 0,
              countInPackage: 0,
              countInTogetherWithFile: 0,
              countInPackageInBasket: 0,
              printPhoto: 0,
            };
          },
        );
        packagesInBasket.forEach(({ packageId }) => {
          packagesInShop.package
            .find((packageInShop) => packageInShop.packageId === packageId)
            .printAndFileConfig.forEach(
              ({ groups, printsCount, mode, forcedImage }) => {
                if (
                  groups.find(
                    (value) =>
                      value ===
                      photoGroupsHasPhoto.find(
                        ({ photoId }) => photoId === this._photoId,
                      ).photoGroupId,
                  ) ||
                  forcedImage?.photoGroupId ===
                    photosList
                      .find(({ photos }) =>
                        photos.find(({ photoId }) => photoId === this._photoId),
                      )
                      .photos.find(({ photoId }) => photoId === this._photoId)
                      .photoGroupId
                ) {
                  if (
                    mode === 'PickedImage' &&
                    forcedImage?.photoId !== this._photoId
                  ) {
                    return;
                  }
                  printsCount.forEach(
                    ({ printPaperId, printFormatId, count }) => {
                      const visiblePrint = visiblePrints.find(
                        (x) =>
                          x.printFormatId === printFormatId &&
                          x.printPaperId === printPaperId,
                      );
                      if (visiblePrint) {
                        visiblePrint.countInPackage += count;
                        if (mode === 'PickedImage') {
                          visiblePrint.minNumber += count;
                        }
                      } else {
                        let minNumber = 0;
                        if (mode === 'PickedImage') {
                          minNumber = count;
                        }
                        visiblePrints.push({
                          maxNumber: 0,
                          minNumber,
                          printPaperId,
                          printFormatId,
                          price: [],
                          onlyPackage: true,
                          inPackage: true,
                          togetherWithFile: false,
                          countInBasket: 0,
                          countInTogetherWithFile: 0,
                          countInPackage: count,
                          countInPackageInBasket: 0,
                          printPhoto: 0,
                        });
                      }
                    },
                  );
                }
              },
            );
        });
        packagesInBasket.forEach(({ print, packageId }) => {
          print.forEach(
            ({ printFormatId, printPaperId, count, printAndFileConfigId }) => {
              if (
                packagesInShop.package
                  .find(({ packageId: p }) => p === packageId)
                  .printAndFileConfig.find(
                    ({ printAndFileConfigId: p }) => p === printAndFileConfigId,
                  )
                  .groups.find(
                    (photoGroupId) =>
                      photoGroupId ===
                      photoGroupsHasPhoto.find(
                        (p) => p.photoId === this._photoId,
                      ).photoGroupId,
                  ) &&
                visiblePrints.find(
                  (x) =>
                    x.printPaperId === printPaperId &&
                    x.printFormatId === printFormatId,
                )
              ) {
                visiblePrints.find(
                  (x) =>
                    x.printPaperId === printPaperId &&
                    x.printFormatId === printFormatId,
                ).countInPackageInBasket += count;
              }
            },
          );
        });
        packagesInBasket.forEach(({ print }) =>
          print
            .filter(({ photoId }) => photoId === this._photoId)
            .forEach(({ printFormatId, printPaperId, count }) => {
              if (
                visiblePrints.find(
                  (x) =>
                    x.printPaperId === printPaperId &&
                    x.printFormatId === printFormatId,
                )
              ) {
                visiblePrints.find(
                  (x) =>
                    x.printPaperId === printPaperId &&
                    x.printFormatId === printFormatId,
                ).printPhoto += count;
              }
            }),
        );
        printsInBasket
          .filter(({ photoId }) => photoId === this._photoId)
          .forEach(
            ({ printPaperId, printFormatId, count, togetherWithFile }) => {
              if (
                visiblePrints.find(
                  (x) =>
                    x.printPaperId === printPaperId &&
                    x.printFormatId === printFormatId,
                )
              ) {
                const print = visiblePrints.find(
                  (x) =>
                    x.printPaperId === printPaperId &&
                    x.printFormatId === printFormatId,
                );
                print.countInBasket += count;
                if (togetherWithFile) {
                  print.countInBasket -= count;
                  print.countInTogetherWithFile = count;
                  print.minNumber += count;
                  print.togetherWithFile = true;
                }
              } else {
                visiblePrints.push({
                  maxNumber: 0,
                  minNumber: count,
                  printPaperId,
                  printFormatId,
                  price: [],
                  onlyPackage: false,
                  inPackage: false,
                  togetherWithFile,
                  countInBasket: 0,
                  countInTogetherWithFile: count,
                  countInPackage: 0,
                  countInPackageInBasket: 0,
                  printPhoto: 0,
                });
              }
            },
          );
        visiblePrints.forEach(
          (
            { countInPackageInBasket, countInBasket, countInPackage },
            index,
          ) => {
            if (countInPackage > countInPackageInBasket) {
              visiblePrints[index].inPackage = true;
            }
          },
        );
        // console.table(visiblePrints);
        return visiblePrints;
      },
    ),
    shareReplay(1),
  );
  addToFirstPrintPrice$ = combineLatest([
    combineLatest([
      this.photosList$,
      this.store.pipe(select(selectSettingPhotoGroup)),
      this.filesInBasket$,
      this.store.pipe(select(selectProductsInBasket)),
      this.store.pipe(select(selectPriceToAddToEveryFileInProduct)),
      this.store.pipe(select(selectPhotoGroups)),
    ]),
    combineLatest([
      this.store.pipe(select(selectFilePrices)),
      this.store.pipe(select(selectPriceToAddToFirstPrint)),
      this.store.pipe(select(selectPrintsInBasket)),
      this.packagesInBasket$,
    ]),
  ]).pipe(
    map(
      ([
        [
          photosList,
          settingPhotoGroup,
          filesInBasket,
          productsInBasket,
          priceToAddToEveryFileInProduct,
          photoGroups,
        ],
        [
          filePrices,
          standardPriceToAddToFirstPrint,
          printsInBasket,
          packagesInBasket,
        ],
      ]) => {
        const groupId = photosList
          .find(({ photos }) =>
            photos.find((photo) => photo.photoId === this._photoId),
          )
          .photos.find((photo) => photo.photoId === this._photoId).photoGroupId;
        const setting = settingPhotoGroup.find(
          ({ photoGroupId }) => photoGroupId === groupId,
        );
        const fileInProduct: { filePricingId: string } = filesInBasket.find(
          ({ photoId: fId }) => fId === this._photoId,
        ) ||
          setting.selectedPricing.filesPricing.find(
            ({ isFull, size }) => !!isFull,
          ) ||
          setting.selectedPricing.filesPricing[0] || {
            filePricingId: 'togetherWithPrint',
          };
        const filePrice = setting.selectedPricing.filesPricing.find(
          ({ filePricingId }) => filePricingId === fileInProduct.filePricingId,
        )?.stepPricing;
        const firstPrintStepContext = getFirstPrintFilePriceStepContext({
          photoGroups,
          photoGroupList: photosList,
          priceToAddToFirstPrint: standardPriceToAddToFirstPrint,
          priceToAddToEveryFileInProduct,
          filePrices,
          printsInBasket,
          filesInBasket,
          productsInBasket,
          packagesInBasket,
          candidate: {
            photoId: this._photoId,
            filePricingId: fileInProduct.filePricingId,
            type: 'print',
          },
        });
        const priceToAddToFirstPrint =
          setting.settings.prints.countWithFilePrices && firstPrintStepContext
            ? singleStepPriceCalculator(
                firstPrintStepContext.index,
                firstPrintStepContext.total,
                filePrice,
                setting.selectedPricing.filesPricing.find(
                  ({ filePricingId }) =>
                    filePricingId === fileInProduct.filePricingId,
                )?.price,
              )
            : setting.settings.prints.countWithFilePrices
              ? []
              : setting.settings.prints.priceToAddToFirstPrint;
        const selectedPrintsPricing = {
          ...setting.settings.prints,
          printsPricing: setting.selectedPricing.printsPricing,
          priceToAddToFirstPrint,
          onlyOneGroup: setting.photoGroupId,
        };
        if (
          (selectedPrintsPricing?.addToFirstPrintPrice &&
            selectedPrintsPricing.skipAddToFirstPrintIfFileBought &&
            !filesInBasket.find((f) => f.photoId === this._photoId) &&
            !packagesInBasket.find(({ file }) =>
              file.find((f) => f.photoId === this._photoId),
            ) &&
            !printsInBasket.find((p) => p.photoId === this._photoId)) ||
          (selectedPrintsPricing?.addToFirstPrintPrice &&
            !selectedPrintsPricing.skipAddToFirstPrintIfFileBought &&
            !printsInBasket.find((p) => p.photoId === this._photoId))
        ) {
          return {
            addToFirstPrintPrice: true,
            price: selectedPrintsPricing.priceToAddToFirstPrint,
          };
        }
        return { addToFirstPrintPrice: false, price: [] };
      },
    ),
  );
  productsInBasketCartWithPhotos$: Observable<
    Array<{
      thisPhotoIsAdd: boolean;
      max: boolean;
      nameClientProduct: string;
      name: string;
      productId: string;
      photosList: Array<{ photoId: string }>;
      configuration: { [x: string]: string | boolean };
      selectedProductId: string;
      quantity: number;
    }>
  > = combineLatest([
    this.productsInBasket$,
    this.productsInShop$,
    this.visibleProducts$,
  ]).pipe(
    map(([productsInBasket, productsInShop, visibleProducts]) => {
      const productInBasket = [];
      const visibleProductIds = visibleProducts.map(
        ({ productId }) => productId,
      );
      productsInBasket.forEach((product) => {
        const images = checkingIfImagesAreRequired(
          productsInShop,
          product.productId,
          Object.entries(product.configuration),
        );
        let max = false;
        if (images.imagesRequired) {
          max = images.requiredImages.max <= product.photoIdList.length;
        }
        if (
          images.imagesRequired &&
          visibleProductIds.includes(product.productId)
        ) {
          productInBasket.push({
            thisPhotoIsAdd:
              product.photoIdList.find(
                (value) => value.photoId === this._photoId,
              )?.photoId === this._photoId,
            max,
            name: productsInShop.find(
              (value) => value.productId === product.productId,
            ).name,
            nameClientProduct: product.nameClientProduct,
            productId: product.productId,
            photosList: product.photoIdList,
            configuration: product.configuration,
            selectedProductId: product.selectedProductId,
            quantity: product.quantity,
          });
        }
      });
      // console.table(productInBasket);
      return productInBasket;
    }),
  );
  @ViewChild('messageAboutChangingThePhotoInTheProduct')
  messageAboutChangingThePhotoInTheProduct;
  @ViewChild('messageAboutSurchargeForFile')
  messageAboutSurchargeForFile;
  swapPhoto$ = new Subject<boolean>();

  @ViewChildren('windowFiles')
  windowFiles: QueryList<any>;

  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));
  lookBookEnabled$ = combineLatest([
    this.store.pipe(
      select(selectConfigSell),
      map(({ lookBookEnabled }) => lookBookEnabled),
    ),
    this.lookbBookDisabledByGroup$,
  ]).pipe(
    map(
      ([lookBookEnabled, lookbBookDisabledByGroup]) =>
        lookBookEnabled && !lookbBookDisabledByGroup,
    ),
  );

  allImages$ = this.store.pipe(
    select(selectPhotosList),
    map((v) => v.reduce((acc, cur) => [...acc, ...cur.photos], [])),
    first(),
  );

  constructor(
    private faceDetectorService: FaceDetectorService,
    private downloader: GetImageUrlService,
    private screenObserver: BreakpointObserver,
    private tooltipService: ZalamoTooltipService,
    private availableFormats: GetAvailablePrintsConfigGQL,
    private fb: TypedFormBuilder,
    private dialog: ZalamoDialogService,
    public cd: ChangeDetectorRef,
    private store: Store<{ shoppingCart: ShoppingCartState }>,
    private noPacketBreakoutWindow: SinglePhotoProductOptionsService,
    private router: Router,
    private route: ActivatedRoute,
    private suggestFreePackage: SuggestPackageAtBeginningService,
    private checkingForMatchingPhotosInProduct: CheckingForMatchingPhotosInProductService,
    private fullscreenService: FullscreenService,
    private autoAddFileToBasketTogetherWithProductService: AutoAddFileToBasketTogetherWithProductService,
    private autoAddFileToBasketTogetherWithPrintInPackageServiceService: AutoAddFileToBasketTogetherWithPrintInPackageServiceService,
    private injector: Injector,
    private translationLoaderService: TranslationLoaderService,
  ) {
    super();
  }

  countingPossibleNumberOfPhotosInProduct(
    files,
    prints,
  ): Array<{ photoId: string }> {
    const photos: Array<{ photoId: string }> = [];
    files.forEach(({ photoId }) => {
      if (!photos.find((x) => x.photoId === photoId)) {
        photos.push({ photoId });
      }
    });
    prints.forEach(({ photoId }) => {
      if (!photos.find((x) => x.photoId === photoId)) {
        photos.push({ photoId });
      }
    });
    return photos;
  }

  ngOnInit(): void {
    this.freePackage$.pipe(first()).subscribe(({ freePackageId }) => {
      this.photoGroupsHasPhoto$
        .pipe(first())
        .subscribe((photoGroupsHasPhoto) => {
          this.packagesInShop$.pipe(first()).subscribe((packagesInShop) => {
            this.packagesInBasket$
              .pipe(first())
              .subscribe((packagesInBasket) => {
                if (
                  freePackageId?.length &&
                  packagesInShop.package.find(
                    ({ packageId }) => packageId === freePackageId,
                  ) &&
                  !this.suggestFreePackage.load() &&
                  !packagesInBasket.find(
                    ({ packageId }) => packageId === freePackageId,
                  ) &&
                  (this.visibleFiles.find(({ size }) =>
                    packagesInShop.package
                      .find(({ packageId }) => packageId === freePackageId)
                      .printAndFileConfig.find(
                        ({ filesConfig, groups, mode, forcedImage }) =>
                          (mode === 'AnyImage' &&
                            filesConfig.find(
                              (f) =>
                                f.size === size &&
                                groups.find(
                                  (groupId) =>
                                    groupId ===
                                    photoGroupsHasPhoto.find(
                                      ({ photoId }) =>
                                        photoId === this._photoId,
                                    ).photoGroupId,
                                ),
                            )) ||
                          forcedImage?.photoId === this._photoId,
                      ),
                  ) ||
                    this.printsPricing.find(({ printFormatId, printPaperId }) =>
                      packagesInShop.package
                        .find(({ packageId }) => packageId === freePackageId)
                        .printAndFileConfig.find(
                          ({ printsCount, groups, mode, forcedImage }) =>
                            (mode === 'AnyImage' &&
                              printsCount.find(
                                (p) =>
                                  p.printPaperId === printPaperId &&
                                  p.printFormatId === printFormatId &&
                                  groups.find(
                                    (groupId) =>
                                      groupId ===
                                      photoGroupsHasPhoto.find(
                                        ({ photoId }) =>
                                          photoId === this._photoId,
                                      ).photoGroupId,
                                  ),
                              )) ||
                            forcedImage?.photoId === this._photoId,
                        ),
                    ))
                ) {
                  const message = this.dialog.openFull(
                    MessageAboutFreePackageComponent,
                  );
                  message.componentInstance.packageInShop =
                    packagesInShop.package.find(
                      ({ packageId }) => packageId === freePackageId,
                    );
                  message.componentInstance.viewDetail
                    .pipe(takeUntil(message.afterClosed()))
                    .subscribe(() => {
                      const detailPackage =
                        this.dialog.openFull(ViewPackageComponent);
                      detailPackage.componentInstance.package =
                        packagesInShop.package.find(
                          ({ packageId }) => packageId === freePackageId,
                        );
                      detailPackage.componentInstance.addPacketToBasket
                        .pipe(takeUntil(detailPackage.afterClosed()))
                        .subscribe(() => {
                          this.store.dispatch(
                            addPackageToBasketAction({
                              package: {
                                packageId: freePackageId,
                                count: 1,
                              },
                            }),
                          );
                          message.close();
                          detailPackage.close();
                        });
                    });
                  message.componentInstance.addPackage
                    .pipe(takeUntil(message.afterClosed()))
                    .subscribe((x) => {
                      if (x) {
                        this.store.dispatch(
                          addPackageToBasketAction({
                            package: {
                              packageId: freePackageId,
                              count: 1,
                            },
                          }),
                        );
                        message.close();
                      } else {
                        message.close();
                      }
                    });
                  this.suggestFreePackage.save(true);
                }
              });
          });
        });
    });
    this.subscribeWhileAlive(
      this.currentPhotoId$.pipe(
        switchMap((photoId) =>
          firstValueFrom(
            this.store.pipe(select(selectCalendarInBasket, { photoId })),
          ),
        ),

        tap((v) => {
          this.calendarUpdateInProgress = true;
          this.calendarInBasket.patchValue(v?.count ?? 0);
          this.calendarUpdateInProgress = false;
        }),
      ),
      combineLatest([
        this.calendarInBasket.valueChanges,
        this.currentPhotoId$,
        this.photoGroupsHasPhoto$,
        this.photoRatio$,
      ]).pipe(
        filter(() => !this.calendarUpdateInProgress),
        tap(([count, photoId, photoGroupHasPhoto, ratio]) =>
          this.store.dispatch(
            addCalendarToBasket({
              calendar: {
                photoId,
                count,
                thumb: this.calendarThumbInBasket.value,
                crop: this.calendarCropInBasket.value,
                photoGroupId: photoGroupHasPhoto.find(
                  (p) => p.photoId === photoId,
                )?.photoGroupId,
                size: ratio >= 1 ? '20x30' : '30x45',
              },
            }),
          ),
        ),
      ),
      this.magnetCountChanges$.pipe(
        withLatestFrom(
          this.currentPhotoId$,
          this.photoGroupsHasPhoto$,
          this.photoRatio$,
        ),
        tap(([{ sizeId, count }, photoId, photoGroupHasPhoto, ratio]) => {
          this.store.dispatch(
            addMagnetToBasket({
              magnet: {
                photoId,
                count,
                thumb: '',
                crop: calculateZalamoMagnetAutoCrop(ratio).xywh,
                photoGroupId: photoGroupHasPhoto.find(
                  (p) => p.photoId === photoId,
                )?.photoGroupId,
                size: sizeId,
              },
            }),
          );
        }),
      ),
      this.model.valueChanges.pipe(
        filter(
          (newValue) =>
            this.oldModel.first !== true &&
            JSON.stringify(this.oldModel.old) !== JSON.stringify(newValue) &&
            JSON.stringify(newValue) !==
              JSON.stringify(
                this.visibleFiles
                  .map(({ size, inPackageOrInBasket }) => ({
                    size,
                    inPackageOrInBasket,
                  }))
                  .reduce(
                    (obj, { size, inPackageOrInBasket }) => ({
                      ...obj,
                      [size]: inPackageOrInBasket,
                    }),
                    {},
                  ),
              ),
        ),
        tap((newValue) => {
          const visibleFiles = cloneDeep(this.visibleFiles);
          this.oldModel.first = true;
          let newFile: VisibleFile & { index: number } = null;
          const oldFile: VisibleFile = visibleFiles.find(
            ({ inPackageOrInBasket }) => inPackageOrInBasket === true,
          );
          if (Object.entries(newValue).find((x) => x[1] === true)) {
            const files = [];
            visibleFiles.forEach(({ size, inPackageOrInBasket }) => {
              if (!inPackageOrInBasket) {
                files.push(
                  Object.entries(newValue).find(
                    (x) => x[0] === JSON.stringify(size),
                  )[0],
                );
              }
            });
            newFile = {
              ...visibleFiles.find(
                ({ size }) =>
                  JSON.stringify(size) ===
                  files.find(
                    (y) =>
                      y ===
                      Object.entries(newValue)
                        .filter((x) => x[0] === JSON.stringify(size))
                        .find((x) => x[1] === true)?.[0],
                  ),
              ),
              togetherWithPrint: !!oldFile ? oldFile.togetherWithPrint : false,
              index: visibleFiles.findIndex(
                ({ size }) =>
                  JSON.stringify(size) ===
                  files.find(
                    (y) =>
                      y ===
                      Object.entries(newValue)
                        .filter((x) => x[0] === JSON.stringify(size))
                        .find((x) => x[1] === true)?.[0],
                  ),
              ),
            };
          }
          const oldModel = Object.entries(newValue);
          if (oldFile) {
            oldModel.find(
              (value) => value[0] === JSON.stringify(oldFile.size),
            )[1] = false;
          }
          if (newFile) {
            oldModel.find(
              (value) => value[0] === JSON.stringify(newFile.size),
            )[1] = true;
          }
          this.oldModel.old = oldModel;
          if (oldFile) {
            let filesInPackage: {
              size: number;
              isFull: boolean;
              printAndFileConfigId: string;
              packageInBasketId: string;
              mode: string;
              togetherWithPrint: boolean;
            } = null;
            combineLatest([this.packagesInBasket$, this.packagesInShop$])
              .pipe(first())
              .subscribe(([packagesInBasket, packagesInShop]) => {
                const currentFileInPackageInBasket = packagesInBasket
                  .find(({ file }) =>
                    file.find(
                      ({ size, photoId }) =>
                        size === oldFile.size && photoId === this._photoId,
                    ),
                  )
                  ?.file.find(
                    ({ size, photoId }) =>
                      size === oldFile.size && photoId === this._photoId,
                  );
                if (currentFileInPackageInBasket) {
                  filesInPackage = {
                    size: oldFile.size,
                    isFull: oldFile.isFull,
                    printAndFileConfigId:
                      currentFileInPackageInBasket.printAndFileConfigId,
                    packageInBasketId: packagesInBasket.find(({ file }) =>
                      file.find(
                        ({ size, photoId }) =>
                          size === oldFile.size && photoId === this._photoId,
                      ),
                    ).packageInBasketId,
                    togetherWithPrint:
                      currentFileInPackageInBasket?.togetherWithPrint
                        ? currentFileInPackageInBasket.togetherWithPrint
                        : false,
                    mode: packagesInShop.package
                      .find(({ printAndFileConfig }) =>
                        printAndFileConfig.find(
                          ({ printAndFileConfigId }) =>
                            printAndFileConfigId ===
                            currentFileInPackageInBasket.printAndFileConfigId,
                        ),
                      )
                      ?.printAndFileConfig.find(
                        ({ printAndFileConfigId }) =>
                          printAndFileConfigId ===
                          currentFileInPackageInBasket.printAndFileConfigId,
                      ).mode,
                  };
                }
              });
            if (filesInPackage && !oldFile.inBasket) {
              this.visiblePrints$.pipe(first()).subscribe((visiblePrints) => {
                if (
                  (this.addPrintFileToBasketIfNotAlreadyBought &&
                    visiblePrints.find(
                      ({ countInBasket }) => countInBasket > 0,
                    )) ||
                  (filesInPackage?.togetherWithPrint &&
                    visiblePrints.find(
                      ({ countInBasket, countInPackageInBasket }) =>
                        countInBasket > 0 || countInPackageInBasket > 0,
                    ))
                ) {
                  if (oldFile) {
                    oldModel.find(
                      (value) => value[0] === JSON.stringify(oldFile.size),
                    )[1] = true;
                  }
                  this.model.setValue(
                    oldModel.reduce(
                      (obj, [x, y]) => ({
                        ...obj,
                        [x]: y,
                      }),
                      {},
                    ),
                  );
                  this.tooltipRef = null;
                  this.cd.detectChanges();
                  this.tooltipRef = this.tooltipService.open(
                    this.translationLoaderService.translate(
                      'productFront',
                      'clhn85sm5000009l9fx2serj1',
                    ),
                    'above',
                    this.windowFiles.find(
                      (v, index) =>
                        index ===
                        visibleFiles.findIndex(
                          ({ inPackageOrInBasket }) =>
                            inPackageOrInBasket === true,
                        ),
                    ).nativeElement,
                  );
                  setTimeout(() => {
                    this.tooltipRef?.close();
                    this.tooltipRef = null;
                  }, 1000);
                } else {
                  switch (filesInPackage.mode) {
                    case 'PickedImage':
                      if (oldFile) {
                        oldModel.find(
                          (value) => value[0] === JSON.stringify(oldFile.size),
                        )[1] = true;
                      }
                      this.model.setValue(
                        oldModel.reduce(
                          (obj, [x, y]) => ({
                            ...obj,
                            [x]: y,
                          }),
                          {},
                        ),
                      );
                      this.tooltipRef = null;
                      this.cd.detectChanges();
                      this.tooltipRef = this.tooltipService.open(
                        this.translationLoaderService.translate(
                          'productFront',
                          'clhn8aott000109l908fq4ikd',
                        ),
                        'above',
                        this.windowFiles.find(
                          (v, index) =>
                            index ===
                            visibleFiles.findIndex(
                              ({ inPackageOrInBasket }) =>
                                inPackageOrInBasket === true,
                            ),
                        ).nativeElement,
                      );
                      setTimeout(() => {
                        this.tooltipRef?.close();
                        this.tooltipRef = null;
                      }, 1000);
                      break;
                    case 'AnyImage':
                      this.store.dispatch(
                        deleteFileInPackageInBasketAction({
                          packageInBasketId: filesInPackage.packageInBasketId,
                          photoId: this._photoId,
                        }),
                      );
                      break;
                    case 'OneImage':
                      this.packagesInShop$
                        .pipe(first())
                        .subscribe((packagesInShop) => {
                          this.packagesInBasket$
                            .pipe(first())
                            .subscribe((packagesInBasket) => {
                              let isAlreadyFile = false;
                              const oneImage = packagesInShop.package
                                .find(
                                  ({ printAndFileConfig }) =>
                                    printAndFileConfig.find(
                                      (printAndFile) =>
                                        printAndFile.printAndFileConfigId ===
                                        filesInPackage.printAndFileConfigId,
                                    )?.printAndFileConfigId ===
                                    filesInPackage.printAndFileConfigId,
                                )
                                ?.printAndFileConfig.find(
                                  (printAndFile) =>
                                    printAndFile.printAndFileConfigId ===
                                    filesInPackage.printAndFileConfigId,
                                );
                              oneImage.filesConfig.forEach((current) => {
                                if (
                                  packagesInBasket.find((packageInBasket) =>
                                    packageInBasket.file.find(
                                      (f) =>
                                        f.size === current.size &&
                                        packagesInShop.package.find(
                                          ({ printAndFileConfig }) =>
                                            printAndFileConfig.find(
                                              ({
                                                printAndFileConfigId,
                                                forcedImage,
                                              }) =>
                                                printAndFileConfigId ===
                                                  f.printAndFileConfigId &&
                                                forcedImage?.photoId ===
                                                  this._photoId,
                                            ),
                                        ),
                                    ),
                                  )
                                ) {
                                  isAlreadyFile = true;
                                }
                              });
                              const printAndFileConf = packagesInShop.package
                                .find(({ printAndFileConfig }) =>
                                  printAndFileConfig.find(
                                    (y) =>
                                      y.printAndFileConfigId ===
                                      filesInPackage.printAndFileConfigId,
                                  ),
                                )
                                .printAndFileConfig.find(
                                  (y) =>
                                    y.printAndFileConfigId ===
                                    filesInPackage.printAndFileConfigId,
                                );
                              const restPrints = [];
                              packagesInBasket.forEach(
                                ({
                                  print,
                                  file,
                                  packageId,
                                  packageInBasketId,
                                }) =>
                                  print
                                    .filter(
                                      ({ photoId }) =>
                                        photoId === this._photoId,
                                    )
                                    .forEach(
                                      ({ printAndFileConfigId, photoId }) => {
                                        const printAndFileConfig =
                                          packagesInShop.package
                                            .find(
                                              (pckg) =>
                                                pckg.packageId === packageId,
                                            )
                                            .printAndFileConfig.find(
                                              (pAndF) =>
                                                pAndF.printAndFileConfigId ===
                                                printAndFileConfigId,
                                            );
                                        if (
                                          printAndFileConfig.mode ===
                                            'OneImage' &&
                                          printAndFileConfig.filesConfig
                                            .length > 0 &&
                                          !file.find(
                                            (f) =>
                                              f.printAndFileConfigId ===
                                                printAndFileConfigId &&
                                              f.photoId === this._photoId,
                                          )
                                        ) {
                                          printAndFileConfig.printsCount.forEach(
                                            (printCount) => {
                                              restPrints.push({
                                                ...printCount,
                                                packageInBasketId,
                                                printAndFileConfigId:
                                                  printAndFileConfig.printAndFileConfigId,
                                                photoId: this._photoId,
                                              });
                                            },
                                          );
                                        }
                                      },
                                    ),
                              );
                              const prints = printAndFileConf.printsCount.map(
                                (p) => ({
                                  count: p.count,
                                  printFormatId: p.printFormatId,
                                  printPaperId: p.printPaperId,
                                  printAndFileConfigId:
                                    filesInPackage.printAndFileConfigId,
                                  photoId: this._photoId,
                                }),
                              );
                              const files = printAndFileConf.filesConfig.map(
                                ({ size, isFull }) => ({
                                  isFull,
                                  size,
                                  printAndFileConfigId:
                                    filesInPackage.printAndFileConfigId,
                                  photoId: this._photoId,
                                }),
                              );
                              this.store.dispatch(
                                deleteFilesAndPrintsInPackageInBasketAction({
                                  packageInBasketId:
                                    filesInPackage.packageInBasketId,
                                  photoId: this._photoId,
                                  printAndFileConfigId:
                                    filesInPackage.printAndFileConfigId,
                                  print: prints,
                                  file: files,
                                }),
                              );
                              if (restPrints.length) {
                                restPrints.forEach((rest) => {
                                  this.store.dispatch(
                                    deletePrintInPackageInBasketAction({
                                      ...rest,
                                    }),
                                  );
                                });
                              }
                            });
                        });
                      break;
                  }
                }
              });
            } else {
              combineLatest([
                this.visiblePrints$,
                this.productsInBasket$,
                this.priceToAddToEveryFileInProduct$,
                this.store.select(selectPriceToAddToEveryFileInLookBookProduct),
                this.store.select(selectLookBookProductsInBasket),
              ])
                .pipe(first())
                .subscribe(
                  ([
                    visiblePrints,
                    productsInBasket,
                    priceToAddToEveryFileInProduct,
                    priceToAddToEveryFileInLookBookProduct,
                    lookBookProductsInBasket,
                  ]) => {
                    const fileTogetherWithPrint = !!(
                      this.addPrintFileToBasketIfNotAlreadyBought &&
                      visiblePrints.find(
                        ({ countInBasket }) => countInBasket > 0,
                      )
                    );
                    const fileTogetherWithProduct =
                      !!(
                        priceToAddToEveryFileInProduct.addEveryFileToBasketIfNotAlreadyBought &&
                        productsInBasket.find(({ photoIdList }) =>
                          photoIdList.find(
                            ({ photoId }) => photoId === this._photoId,
                          ),
                        )
                      ) ||
                      !!(
                        priceToAddToEveryFileInLookBookProduct.addEveryFileToBasketIfNotAlreadyBought &&
                        lookBookProductsInBasket.find(({ photoIdList }) =>
                          photoIdList.find(
                            (photoId) => photoId === this._photoId,
                          ),
                        )
                      );
                    if (fileTogetherWithPrint || fileTogetherWithProduct) {
                      if (oldFile) {
                        oldModel.find(
                          (value) => value[0] === JSON.stringify(oldFile.size),
                        )[1] = true;
                      }
                      this.model.setValue(
                        oldModel.reduce(
                          (obj, [x, y]) => ({
                            ...obj,
                            [x]: y,
                          }),
                          {},
                        ),
                      );
                      let text = '';
                      switch (true) {
                        case fileTogetherWithPrint && fileTogetherWithProduct:
                          text = this.translationLoaderService.translate(
                            'productFront',
                            'clhn8dyxg000209l9bmi85x3r',
                          );
                          break;
                        case fileTogetherWithPrint:
                          text = this.translationLoaderService.translate(
                            'productFront',
                            'clhn85sm5000009l9fx2serj1',
                          );
                          break;
                        case fileTogetherWithProduct:
                          text = this.translationLoaderService.translate(
                            'productFront',
                            'clhn8e2sm000309l944p72nuc',
                          );
                          break;
                      }
                      this.tooltipRef = null;
                      this.cd.detectChanges();
                      this.tooltipRef = this.tooltipService.open(
                        text,
                        'above',
                        this.windowFiles.find(
                          (v, index) =>
                            index ===
                            visibleFiles.findIndex(
                              ({ inPackageOrInBasket }) =>
                                inPackageOrInBasket === true,
                            ),
                        ).nativeElement,
                      );
                      setTimeout(() => {
                        this.tooltipRef?.close();
                        this.tooltipRef = null;
                      }, 1000);
                    } else if (
                      (this.addPrintFileToBasketIfNotAlreadyBought &&
                        visiblePrints.find(
                          ({ countInBasket }) => countInBasket === 0,
                        )) ||
                      !this.addPrintFileToBasketIfNotAlreadyBought
                    ) {
                      this.store.dispatch(
                        deleteFileInBasketAction({
                          photoId: this._photoId,
                        }),
                      );
                      this.printsInBasket$
                        .pipe(first())
                        .subscribe((printsInBasket) => {
                          printsInBasket
                            .filter(
                              ({ togetherWithFile, photoId }) =>
                                !!togetherWithFile && photoId === this._photoId,
                            )
                            .forEach(({ printId }) =>
                              this.store.dispatch(
                                deletePrintAction({
                                  printId,
                                }),
                              ),
                            );
                        });
                    }
                  },
                );
            }
          }
          if (newFile) {
            let fileAddToPackage =
              this.findMatchingFile(newFile).fileAddToPackage;
            let photoCannotBeReplaced =
              this.findMatchingFile(newFile).photoCannotBeReplaced;
            if (photoCannotBeReplaced) {
              const files = cloneDeep(Object.entries(newValue));
              files.find((x) => x[0] === JSON.stringify(newFile.size))[1] =
                false;
              this.model.setValue(
                files.reduce(
                  (obj, [x, y]) => ({
                    ...obj,
                    [x]: y,
                  }),
                  {},
                ),
              );
              this.oldModel.old = files.reduce(
                (obj, [x, y]) => ({
                  ...obj,
                  [x]: y,
                }),
                {},
              );
              this.tooltipRef = null;
              this.cd.detectChanges();
              this.tooltipRef = this.tooltipService.open(
                this.translationLoaderService.translate(
                  'productFront',
                  'clhn9rf13000108l25gs2a5vl',
                ),
                'above',
                this.windowFiles.find(
                  (v, index) =>
                    index ===
                    visibleFiles.findIndex(
                      ({ inPackageOrInBasket }) => inPackageOrInBasket === true,
                    ),
                ).nativeElement,
              );
              setTimeout(() => {
                this.tooltipRef?.close();
                this.tooltipRef = null;
              }, 1000);
            } else {
              this.visiblePrints$.pipe(first()).subscribe((visiblePrints) => {
                if (
                  this.addPrintFileToBasketIfNotAlreadyBought &&
                  visiblePrints.find(({ countInBasket }) => countInBasket > 0)
                ) {
                  this.store.dispatch(
                    addFileInBasketAction({
                      file: {
                        photoId: this._photoId,
                        isFull: newFile.isFull,
                        togetherWithProduct: false,
                        togetherWithPrint: newFile.togetherWithPrint,
                        size: newFile.size,
                        filePricingId: newFile.filePricingId,
                        retouchLevelId: 'standard',
                      },
                    }),
                  );
                } else {
                  if (
                    fileAddToPackage &&
                    fileAddToPackage.countInPackage > 0 &&
                    newFile.freeSpaceInPackage > 0
                  ) {
                    switch (fileAddToPackage.mode) {
                      case 'OneImage':
                        this.packagesInShop$
                          .pipe(first())
                          .subscribe((packagesInShop) => {
                            const printAndFile = packagesInShop.package
                              .find(({ printAndFileConfig }) =>
                                printAndFileConfig.find(
                                  (y) =>
                                    y.printAndFileConfigId ===
                                    fileAddToPackage.printAndFileConfigId,
                                ),
                              )
                              .printAndFileConfig.find(
                                (y) =>
                                  y.printAndFileConfigId ===
                                  fileAddToPackage.printAndFileConfigId,
                              );
                            this.store.dispatch(
                              addOneImageInPackageToBasketAction({
                                package: {
                                  printAndFileConfigId:
                                    fileAddToPackage.printAndFileConfigId,
                                  packageInBasketId:
                                    fileAddToPackage.packageInBasketId,
                                  file: printAndFile.filesConfig.map(
                                    ({ size, isFull }) => ({
                                      isFull,
                                      size,
                                      printAndFileConfigId:
                                        fileAddToPackage.printAndFileConfigId,
                                      photoId: this._photoId,
                                    }),
                                  ),
                                  print: printAndFile.printsCount.map((p) => ({
                                    count: p.count,
                                    printFormatId: p.printFormatId,
                                    printPaperId: p.printPaperId,
                                    printAndFileConfigId:
                                      fileAddToPackage.printAndFileConfigId,
                                    photoId: this._photoId,
                                  })),
                                },
                              }),
                            );
                          });
                        break;
                      case 'AnyImage':
                        this.store.dispatch(
                          addFileInPackageToBasketAction({
                            packageInBasketId:
                              fileAddToPackage.packageInBasketId,
                            file: {
                              photoId: this._photoId,
                              isFull: fileAddToPackage.isFull,
                              size: fileAddToPackage.size,
                              printAndFileConfigId:
                                fileAddToPackage.printAndFileConfigId,
                            },
                          }),
                        );
                        break;
                    }
                  } else {
                    if (newFile.onlyPackage) {
                      this.tooltipRef = null;
                      this.cd.detectChanges();
                      this.tooltipRef = this.tooltipService.open(
                        this.translationLoaderService.translate(
                          'productFront',
                          'clhn9rt1a000208l2dlcs97t7',
                        ),
                        'above',
                        this.windowFiles.find(
                          (v, index) =>
                            index ===
                            visibleFiles.findIndex(
                              ({ size }) => size === newFile.size,
                            ),
                        ).nativeElement,
                      );
                      this.model.setValue(
                        oldModel.reduce(
                          (obj, [x, y], index) => ({
                            ...obj,
                            [x]: newFile.index === index ? false : y,
                          }),
                          {},
                        ),
                      );
                      setTimeout(() => {
                        this.tooltipRef?.close();
                        this.tooltipRef = null;
                      }, 1000);
                    } else {
                      let packageInBasket = false;
                      this.packagesInBasket$
                        .pipe(first())
                        .subscribe((packagesInBasket) => {
                          packageInBasket = packagesInBasket.length > 0;
                        });
                      this.configSell$
                        .pipe(first())
                        .subscribe(({ sellPackages }) => {
                          this.packagesInShop$.pipe(first()).subscribe((p) => {
                            const matchingPackages: Array<Package> = [];
                            const mismatchingPackages: Array<Package> = [];
                            this.photoGroupsHasPhoto$
                              .pipe(first())
                              .subscribe((photoGroupsHasPhoto) => {
                                p.package.forEach((packageInShop) => {
                                  if (
                                    packageInShop.printAndFileConfig.find(
                                      ({
                                        filesConfig,
                                        groups,
                                        forcedImage,
                                        mode,
                                      }) =>
                                        (mode === 'PickedImage' &&
                                          forcedImage.photoId ===
                                            this._photoId &&
                                          filesConfig.find(
                                            ({ size }) => size === newFile.size,
                                          )) ||
                                        (mode !== 'PickedImage' &&
                                          groups.find(
                                            (group) =>
                                              group ===
                                              photoGroupsHasPhoto.find(
                                                ({ photoId }) =>
                                                  photoId === this._photoId,
                                              ).photoGroupId,
                                          ) &&
                                          filesConfig.find(
                                            ({ size }) => size === newFile.size,
                                          )),
                                    )
                                  ) {
                                    matchingPackages.push(packageInShop);
                                  } else {
                                    mismatchingPackages.push(packageInShop);
                                  }
                                });
                              });
                            if (
                              matchingPackages.length > 0 &&
                              !packageInBasket &&
                              !this.noPacketBreakoutWindow.load() &&
                              sellPackages &&
                              p.package.length
                            ) {
                              if (matchingPackages.length) {
                                const ref = this.dialog.openFull(
                                  PackagesListComponent,
                                );
                                this.isPhonePortrait$
                                  .pipe(takeUntil(ref.afterClosed()))
                                  .subscribe(
                                    (isPhonePortrait) =>
                                      (ref._containerInstance.isBare =
                                        isPhonePortrait),
                                  );
                                ref.componentInstance.matchingPackage =
                                  matchingPackages;
                                ref.componentInstance.notMatchingPackage =
                                  mismatchingPackages;
                                ref
                                  .beforeClosed()
                                  .pipe(takeUntil(ref.afterClosed()))
                                  .subscribe(() => {
                                    if (!this.closeOpenedDialog) {
                                      this.addFileToBasket(newFile);
                                    }
                                    this.closeOpenedDialog = false;
                                  });
                                ref.componentInstance.closeWindow
                                  .pipe(takeUntil(ref.afterClosed()))
                                  .subscribe(() => {
                                    this.noPacketBreakoutWindow.save(true);
                                    ref.close();
                                  });
                                ref.componentInstance.addPackage
                                  .pipe(takeUntil(ref.afterClosed()))
                                  .subscribe((packageId) => {
                                    this.closeOpenedDialog = true;
                                    this.oldModel.first = true;
                                    this.store.dispatch(
                                      addPackageToBasketAction({
                                        package: { packageId, count: 1 },
                                      }),
                                    );
                                    fileAddToPackage =
                                      this.findMatchingFile(
                                        newFile,
                                      ).fileAddToPackage;
                                    photoCannotBeReplaced =
                                      this.findMatchingFile(
                                        newFile,
                                      ).photoCannotBeReplaced;
                                    if (photoCannotBeReplaced) {
                                      this.oldModel.first = false;
                                      ref.close();
                                    } else {
                                      if (
                                        fileAddToPackage &&
                                        fileAddToPackage.countInPackage > 0
                                      ) {
                                        switch (fileAddToPackage.mode) {
                                          case 'OneImage':
                                            this.packagesInShop$
                                              .pipe(first())
                                              .subscribe((x) => {
                                                const printAndFile = x.package
                                                  .find(
                                                    ({ printAndFileConfig }) =>
                                                      printAndFileConfig.find(
                                                        (y) =>
                                                          y.printAndFileConfigId ===
                                                          fileAddToPackage.printAndFileConfigId,
                                                      ),
                                                  )
                                                  .printAndFileConfig.find(
                                                    (y) =>
                                                      y.printAndFileConfigId ===
                                                      fileAddToPackage.printAndFileConfigId,
                                                  );
                                                this.store.dispatch(
                                                  addOneImageInPackageToBasketAction(
                                                    {
                                                      package: {
                                                        printAndFileConfigId:
                                                          fileAddToPackage.printAndFileConfigId,
                                                        packageInBasketId:
                                                          fileAddToPackage.packageInBasketId,
                                                        file: printAndFile.filesConfig.map(
                                                          ({
                                                            size,
                                                            isFull,
                                                          }) => ({
                                                            isFull,
                                                            size,
                                                            printAndFileConfigId:
                                                              fileAddToPackage.printAndFileConfigId,
                                                            photoId:
                                                              this._photoId,
                                                          }),
                                                        ),
                                                        print:
                                                          printAndFile.printsCount.map(
                                                            ({
                                                              count,
                                                              printFormatId,
                                                              printPaperId,
                                                            }) => ({
                                                              count,
                                                              printFormatId,
                                                              printPaperId,
                                                              printAndFileConfigId:
                                                                fileAddToPackage.printAndFileConfigId,
                                                              photoId:
                                                                this._photoId,
                                                            }),
                                                          ),
                                                      },
                                                    },
                                                  ),
                                                );
                                              });
                                            break;
                                          case 'AnyImage':
                                            this.store.dispatch(
                                              addFileInPackageToBasketAction({
                                                packageInBasketId:
                                                  fileAddToPackage.packageInBasketId,
                                                file: {
                                                  photoId: this._photoId,
                                                  isFull:
                                                    fileAddToPackage.isFull,
                                                  size: fileAddToPackage.size,
                                                  printAndFileConfigId:
                                                    fileAddToPackage.printAndFileConfigId,
                                                },
                                              }),
                                            );
                                            break;
                                        }
                                        ref.close();
                                      } else {
                                        this.addFileToBasket(newFile);
                                      }
                                      this.oldModel.first = false;
                                      ref.close();
                                    }
                                  });
                              } else {
                                this.addFileToBasket(newFile);
                              }
                            } else {
                              this.addFileToBasket(newFile);
                            }
                          });
                        });
                    }
                  }
                }
              });
            }
          }
          this.oldModel.first = false;
        }),
      ),
      this.packagesInBasket$.pipe(
        filter((packagesInBasket) => !!JSON.stringify(packagesInBasket)),
        tap((packagesInBasket) => {
          packagesInBasket.forEach(({ packageInBasketId }) => {
            this.checkingForMatchingPhotosInProduct.checkingForMatchingPhotosInProduct(
              packageInBasketId,
            );
          });
        }),
      ),
    );
  }

  addFileToBasket(file: VisibleFile & { index: number }) {
    this.productsInBasket$.pipe(first()).subscribe((productsInBasket) => {
      this.priceToAddToEveryFileInProduct$
        .pipe(first())
        .subscribe((priceToAddToEveryFileInProduct) => {
          const printsIncluded = this.filesPricing.find(
            ({ size, isFull }) => size === file.size && isFull === file.isFull,
          )?.printsIncluded;
          this.store.dispatch(
            addFileInBasketAction({
              file: {
                photoId: this._photoId,
                isFull: file.isFull,
                size: file.size,
                filePricingId: file.filePricingId,
                togetherWithPrint: false,
                togetherWithProduct: !!(
                  !!priceToAddToEveryFileInProduct.addEveryFileToBasketIfNotAlreadyBought &&
                  !!productsInBasket.find(({ photoIdList }) =>
                    photoIdList.find(
                      ({ photoId }) => photoId === this._photoId,
                    ),
                  )
                ),
                retouchLevelId: 'standard',
              },
            }),
          );
          if (
            printsIncluded?.length &&
            (!priceToAddToEveryFileInProduct.addEveryFileToBasketIfNotAlreadyBought ||
              (!productsInBasket.find(({ photoIdList }) =>
                photoIdList.find(({ photoId }) => photoId === this._photoId),
              ) &&
                !!priceToAddToEveryFileInProduct.addEveryFileToBasketIfNotAlreadyBought))
          ) {
            this.store.dispatch(
              addPrintsListToBasketAction({
                prints: printsIncluded.map(
                  ({ printPaperId, printFormatId, count }) => ({
                    photoId: this._photoId,
                    printId: cuid(),
                    togetherWithFile: true,
                    count,
                    printFormatId,
                    printPaperId,
                  }),
                ),
              }),
            );
            this.tooltipRef = null;
            this.cd.detectChanges();
            this.tooltipRef = this.tooltipService.open(
              this.translationLoaderService.translate(
                'productFront',
                printsIncluded.length > 1 || printsIncluded[0].count > 1
                  ? 'clhoisfa1000208l8hjzv4gp0'
                  : 'clhoiskpq000308l89l5s0w9o',
              ),
              'above',
              this.windowFiles.find((v, index) => index === file.index)
                .nativeElement,
            );
            setTimeout(() => {
              this.tooltipRef?.close();
              this.tooltipRef = null;
            }, 1000);
          }
        });
    });
  }

  changeRetouchFile(retouchLevelId: string) {
    this.store.dispatch(
      changeRetouchInFileAction({
        photoId: this._photoId,
        retouchLevelId,
      }),
    );
  }

  findMatchingFile(newFile: VisibleFile & { index: number }) {
    const filesInPackage: Array<{
      size: number;
      isFull: boolean;
      countInPackage: number;
      printAndFileConfigId: string;
      packageInBasketId: string;
      mode: string;
      forcedImage: boolean;
    }> = [];
    this.packagesInBasket$.pipe(first()).subscribe((packagesInBasket) => {
      this.packagesInShop$.pipe(first()).subscribe((packagesInShop) => {
        this.photoGroupsHasPhoto$.pipe(first()).subscribe((photoGroup) => {
          packagesInBasket.forEach(
            ({ file, print, packageInBasketId, packageId }) => {
              packagesInShop.package
                .find((x) => x.packageId === packageId)
                .printAndFileConfig.filter(({ groups }) =>
                  groups.find(
                    (group) =>
                      group ===
                      photoGroup.find(
                        ({ photoId }) => photoId === this._photoId,
                      ).photoGroupId,
                  ),
                )
                .forEach(
                  ({
                    filesConfig,
                    printAndFileConfigId,
                    mode,
                    forcedImage,
                  }) => {
                    filesConfig.forEach(({ size, isFull, count }) => {
                      filesInPackage.push({
                        size,
                        isFull,
                        countInPackage: count,
                        printAndFileConfigId,
                        packageInBasketId,
                        mode,
                        forcedImage: forcedImage?.photoId === this._photoId,
                      });
                      file
                        .filter(
                          (current) =>
                            (current.isFull === isFull &&
                              current.size === size &&
                              current.printAndFileConfigId ===
                                printAndFileConfigId) ||
                            print.find(
                              (p) =>
                                p.printAndFileConfigId === printAndFileConfigId,
                            ),
                        )
                        .forEach(() => {
                          filesInPackage.find(
                            (a) =>
                              a.printAndFileConfigId === printAndFileConfigId &&
                              a.packageInBasketId === packageInBasketId,
                          ).countInPackage -= 1;
                        });
                    });
                  },
                );
            },
          );
        });
      });
    });
    const photoCannotBeReplaced = filesInPackage.find(
      ({ forcedImage }) => forcedImage === true,
    );
    const fileAddToPackage = filesInPackage.find(
      ({ size, countInPackage }) => size === newFile.size && countInPackage > 0,
    );
    return { photoCannotBeReplaced, fileAddToPackage };
  }

  previewProductInPacket(product, packageInBasketId: string) {
    const ref = this.dialog.openFull(PreviewProductInBasketComponent);
    this.isPhonePortrait$
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe((isPhonePortrait) => {
        ref._containerInstance.isBare = isPhonePortrait;
      });
    this.productsInShop$.pipe(first()).subscribe((availableProducts) => {
      ref.componentInstance.product = availableProducts.find(
        ({ productId }) => productId === product.productId,
      );
    });
    ref.componentInstance.context = this.context;
    ref.componentInstance.contextId = this.contextId;
    ref.componentInstance.packageId = product.packageId;
    ref.componentInstance.photoIdList = [{ photoId: this._photoId }];
    ref.componentInstance.photosSelectedByPhotographer =
      product.photosSelectedByPhotographer;
    ref.componentInstance.productInPackageId = product.productInPackageId;
    ref.componentInstance.swap = false;
    ref.componentInstance.packageInBasketId = packageInBasketId;
    ref.componentInstance.max = product.qty;
    ref.componentInstance.inPackage = true;
    ref.componentInstance.hideDialog
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        ref.close();
      });
  }

  previewSelectedProductInPacket(packageInBasketId: string, product) {
    const ref = this.dialog.openFull(PreviewProductInBasketComponent);
    this.isPhonePortrait$
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe((isPhonePortrait) => {
        ref._containerInstance.isBare = isPhonePortrait;
      });
    this.productsInShop$.pipe(first()).subscribe((availableProducts) => {
      ref.componentInstance.product = availableProducts.find(
        ({ productId }) => productId === product.productId,
      );
    });
    ref.componentInstance.packageId = product.packageId;
    ref.componentInstance.photosSelectedByPhotographer =
      product.photosSelectedByPhotographer;
    ref.componentInstance.productInPackageId = product.productInPackageId;
    ref.componentInstance.packageInBasketId = packageInBasketId;
    ref.componentInstance.max = product.count;
    ref.componentInstance.inPackage = true;
    ref.componentInstance.selectedProductId = product.selectedProductId;
    ref.componentInstance.config = product.config;
    ref.componentInstance.photoIdList = product.photos;
    ref.componentInstance.nameClientProduct = product.nameClientProduct;
    ref.componentInstance.quantity = product.count;
    ref.componentInstance.swap = true;
    ref.componentInstance.hideDialog
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        ref.close();
      });
  }

  showPrintDetails(printFormatId, printPaperId) {
    const ref = this.dialog.openRight(PrintDetailsComponent);
    const { componentInstance } = ref;
    componentInstance.printPaperId = printPaperId;
    componentInstance.printFormatId = printFormatId;
  }

  previewProduct(product: Product) {
    const ref = this.dialog.openFull(ProductCardComponent);
    this.isPhonePortrait$
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe((isPhonePortrait) => {
        ref._containerInstance.isBare = isPhonePortrait;
      });
    ref.componentInstance.product = {
      ...product,
      configurationImages: this.checkingIfItIsString(
        product.configurationImages,
      ),
      config: this.checkingIfItIsString(product.config),
      composedImages: this.checkingIfItIsString(product.composedImages),
    };
    ref.componentInstance.context = this.context;
    ref.componentInstance.contextId = this.contextId;
    ref.componentInstance.photoIdList = [{ photoId: this._photoId }];
    ref.componentInstance.hideDialog
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => ref.close());
  }

  editProduct(selectedProductId: string) {
    this.productsInBasketCartWithPhotos$
      .pipe(first())
      .subscribe((productsInBasket) => {
        this.productsInShop$.pipe(first()).subscribe((productsInShop) => {
          const product = productsInBasket.find(
            (value) => value.selectedProductId === selectedProductId,
          );
          const found = productsInShop.find(
            ({ productId }) => productId === product.productId,
          );
          const ref = this.dialog.openFull(ProductCardComponent);
          this.isPhonePortrait$
            .pipe(takeUntil(ref.afterClosed()))
            .subscribe((isPhonePortrait) => {
              ref._containerInstance.isBare = isPhonePortrait;
            });
          ref.componentInstance.product = {
            ...product,
            ...found,
            hasWizard: null,
            status: null,
            tags: [],
            availableOnOccasion: null,
            configurationImages: this.checkingIfItIsString(
              found.configurationImages,
            ),
            config: this.checkingIfItIsString(found.config),
            composedImages: this.checkingIfItIsString(found.composedImages),
            taxConfig: null,
            hasTaxConfig: false,
          };
          ref.componentInstance.context = this.context;
          ref.componentInstance.contextId = this.contextId;
          ref.componentInstance.preConfiguration.next(product.configuration);
          ref.componentInstance.quantity = product.quantity;
          ref.componentInstance.photoIdList = product.photosList;
          ref.componentInstance.swap = true;
          ref.componentInstance.selectedProductId = selectedProductId;
          ref.componentInstance.nameClientProduct = product.nameClientProduct;
          ref.componentInstance.hideDialog
            .pipe(takeUntil(ref.afterClosed()))
            .subscribe(() => ref.close());
        });
      });
  }

  checkingIfItIsString(value) {
    return typeof value === 'string' ? JSON.parse(value) : value;
  }

  addPhotoToProduct(selectedProductId) {
    this.priceToAddToEveryFileInProduct$
      .pipe(first())
      .subscribe((priceToAddToEveryFileInProduct) =>
        this.productsInBasket$.pipe(first()).subscribe((productsInBasket) => {
          const { photoIdList, firstAddedFile } = productsInBasket.find(
            (p) => p.selectedProductId === selectedProductId,
          );
          if (
            !photoIdList.length &&
            !firstAddedFile &&
            priceToAddToEveryFileInProduct.addPriceToEveryFileInProduct
          ) {
            this.fullscreenService.open<any, { response: number }>({
              content: this.messageAboutSurchargeForFile,
              data: {
                mode: 'warn',
              },
            });
          }
          this.store.dispatch(
            addPhotoToProductInBasket({
              product: {
                selectedProductId,
                photoId: this._photoId,
              },
            }),
          );
        }),
      );
    this.autoAddFileToBasketTogetherWithProductService.autoAddFileToBasketTogetherWithProduct();
  }

  removePhotoToProduct(selectedProductId) {
    this.store.dispatch(
      deletePhotoToProductInBasket({
        product: {
          selectedProductId,
          photoId: this._photoId,
        },
      }),
    );
    this.autoAddFileToBasketTogetherWithProductService.autoAddFileToBasketTogetherWithProduct();
  }

  changePrintQuantity(
    x: number,
    c: VisiblePrint,
    target: ChangeNumberComponent,
  ) {
    let numberDifference = cloneDeep(x);
    const oldNumber = cloneDeep(x);
    const changePrint = cloneDeep(c);
    let printsInPackage =
      this.findMatchPrintInPackage(changePrint).printsInPackage;
    let packageInBasket =
      this.findMatchPrintInPackage(changePrint).packageInBasket;
    const packagesInShop =
      this.findMatchPrintInPackage(changePrint).packagesInShop;
    if (numberDifference > 0) {
      numberDifference = this.addPrintInPackageToBasket(
        printsInPackage,
        numberDifference,
        target,
      );
      if (
        numberDifference !== 0 &&
        oldNumber - numberDifference <=
          changePrint.maxNumber + changePrint.countInPackageInBasket
      ) {
        if (changePrint.onlyPackage) {
          this.tooltipRef = this.tooltipService.open(
            this.translationLoaderService.translate(
              'productFront',
              'clhn9rt1a000208l2dlcs97t7',
            ),
            'above',
            target.elementRef.nativeElement,
          );
          setTimeout(() => {
            this.tooltipRef?.close();
            this.tooltipRef = null;
          }, 1000);
        } else {
          const matchingPackages: Array<Package> = [];
          const mismatchingPackages: Array<Package> = [];
          this.photoGroupsHasPhoto$
            .pipe(first())
            .subscribe((photoGroupsHasPhoto) => {
              packagesInShop.forEach((packageInShop) => {
                if (
                  packageInShop.printAndFileConfig.find(
                    ({ forcedImage, groups, printsCount, mode }) =>
                      (mode === 'PickedImage' &&
                        forcedImage.photoId === this._photoId &&
                        printsCount.find(
                          ({ printFormatId, printPaperId }) =>
                            printPaperId === changePrint.printPaperId &&
                            printFormatId === changePrint.printFormatId,
                        )) ||
                      (mode !== 'PickedImage' &&
                        groups.find(
                          (group) =>
                            group ===
                            photoGroupsHasPhoto.find(
                              ({ photoId }) => photoId === this._photoId,
                            ).photoGroupId,
                        ) &&
                        printsCount.find(
                          ({ printFormatId, printPaperId }) =>
                            printPaperId === changePrint.printPaperId &&
                            printFormatId === changePrint.printFormatId,
                        )),
                  )
                ) {
                  matchingPackages.push({ ...packageInShop });
                } else {
                  mismatchingPackages.push({ ...packageInShop });
                }
              });
            });
          this.configSell$.pipe(first()).subscribe(({ sellPackages }) => {
            if (
              !packageInBasket &&
              !this.noPacketBreakoutWindow.load() &&
              sellPackages &&
              packagesInShop.length &&
              matchingPackages.length > 0
            ) {
              const ref = this.dialog.openFull(PackagesListComponent);
              this.isPhonePortrait$
                .pipe(takeUntil(ref.afterClosed()))
                .subscribe(
                  (isPhonePortrait) =>
                    (ref._containerInstance.isBare = isPhonePortrait),
                );
              ref.componentInstance.matchingPackage = matchingPackages;
              ref.componentInstance.notMatchingPackage = mismatchingPackages;
              ref
                .beforeClosed()
                .pipe(takeUntil(ref.afterClosed()))
                .subscribe(() => {
                  if (!this.closeOpenedDialog) {
                    this.addPrintWithoutPackage(
                      target,
                      numberDifference,
                      changePrint.printFormatId,
                      changePrint.printPaperId,
                    );
                  }
                  this.closeOpenedDialog = false;
                });
              ref.componentInstance.closeWindow
                .pipe(takeUntil(ref.afterClosed()))
                .subscribe(() => {
                  this.noPacketBreakoutWindow.save(true);
                  ref.close();
                });
              ref.componentInstance.addPackage
                .pipe(takeUntil(ref.afterClosed()))
                .subscribe((packageId) => {
                  this.closeOpenedDialog = true;
                  if (
                    matchingPackages.find(
                      (value) => value.packageId === packageId,
                    )
                  ) {
                    this.store.dispatch(
                      addPackageToBasketAction({
                        package: { packageId, count: 1 },
                      }),
                    );
                    printsInPackage =
                      this.findMatchPrintInPackage(changePrint).printsInPackage;
                    packageInBasket =
                      this.findMatchPrintInPackage(changePrint).packageInBasket;
                    numberDifference = this.addPrintInPackageToBasket(
                      printsInPackage,
                      numberDifference,
                      target,
                    );
                    if (numberDifference > 0) {
                      this.addPrintWithoutPackage(
                        target,
                        numberDifference,
                        changePrint.printFormatId,
                        changePrint.printPaperId,
                      );
                    }
                  } else {
                    this.store.dispatch(
                      addPackageToBasketAction({
                        package: { packageId, count: 1 },
                      }),
                    );
                    this.addPrintWithoutPackage(
                      target,
                      numberDifference,
                      changePrint.printFormatId,
                      changePrint.printPaperId,
                    );
                  }
                  ref.close();
                });
            } else {
              this.addPrintWithoutPackage(
                target,
                numberDifference,
                changePrint.printFormatId,
                changePrint.printPaperId,
              );
            }
          });
        }
      }
    } else {
      let changeCount = 0;
      this.printsInBasket$.pipe(first()).subscribe((y) => {
        const count = y.find(
          ({ printFormatId, printPaperId, photoId, togetherWithFile }) =>
            printFormatId === changePrint.printFormatId &&
            printPaperId === changePrint.printPaperId &&
            !togetherWithFile &&
            photoId === this._photoId,
        )?.count;
        if (count) {
          if (count + numberDifference > 0) {
            this.addPrintWithoutPackage(
              target,
              numberDifference,
              changePrint.printFormatId,
              changePrint.printPaperId,
            );
            changeCount = numberDifference;
          } else {
            this.addPrintWithoutPackage(
              target,
              -count,
              changePrint.printFormatId,
              changePrint.printPaperId,
            );
            changeCount = -count;
          }
        }
        numberDifference -= changeCount;
        if (numberDifference !== 0) {
          numberDifference = this.addPrintInPackageToBasket(
            printsInPackage,
            numberDifference,
            target,
          );
        }
      });
    }
  }

  editWallDecor(preset) {
    const ref = this.dialog.openFull(PublicSessionWallDecorEditorComponent, {
      isBare: true,
    });
    ref.componentInstance.isSinglePhotoMode =
      this.disablePersonalizationOnSinglePhotoWallDecor;
    if (preset) {
      ref.componentInstance.preset = preset;
    }
    this.photoRatio$
      .pipe(
        tap((ratio) => (ref.componentInstance.photoRatio = ratio)),
        first(),
      )
      .subscribe();

    this.store
      .pipe(select(selectShoppingCartContext))

      .pipe(
        tap(({ context, contextId }) => {
          switch (context) {
            case 'PublicSession':
              ref.componentInstance.publicSessionId = contextId;

              break;
          }
        }),
        first(),
      )
      .subscribe();
    ref.componentInstance.closed
      .pipe(
        tap(() => {
          ref.close();
        }),
        takeUntil(ref.afterClosed()),
      )
      .subscribe();
  }

  editTambour(preset) {
    const ref = this.dialog.openFull(PublicSessionWallDecorEditorComponent, {
      isBare: true,
    });
    ref.componentInstance.type = WallDecorPieceForDisplayType.Tambour;
    ref.componentInstance.isSinglePhotoMode =
      this.disablePersonalizationOnSinglePhotoTambour;

    this.store
      .pipe(select(selectShoppingCartContext))
      .pipe(
        tap(({ context, contextId }) => {
          switch (context) {
            case 'PublicSession':
              ref.componentInstance.publicSessionId = contextId;

              break;
          }
        }),
        first(),
      )
      .subscribe();
    if (preset) {
      ref.componentInstance.preset = preset;
      // }
    }
    ref.componentInstance.closed
      .pipe(
        tap(() => {
          ref.close();
        }),
        takeUntil(ref.afterClosed()),
      )
      .subscribe();
  }

  findMatchPrintInPackage(changePrint) {
    const printsInPackage: Array<PrintInPackage> = [];
    let packageInBasket = false;
    let packagesInShop: Array<Package> = [];
    this.packagesInShop$.pipe(first()).subscribe((p) =>
      this.packagesInBasket$.pipe(first()).subscribe((packagesInBasket) => {
        this.photoGroupsHasPhoto$.pipe(first()).subscribe((photoGroups) => {
          packagesInShop = p.package;
          if (packagesInBasket.length) {
            packageInBasket = true;
          }
          packagesInBasket.forEach(
            ({ packageId, packageInBasketId, print }) => {
              packagesInShop
                .find((value) => value.packageId === packageId)
                .printAndFileConfig.filter(({ groups }) =>
                  groups.find(
                    (group) =>
                      group ===
                      photoGroups.find(
                        ({ photoId }) => photoId === this._photoId,
                      ).photoGroupId,
                  ),
                )
                .forEach(
                  ({
                    addFileToPrintInPackage,
                    printsCount,
                    mode,
                    printAndFileConfigId,
                  }) => {
                    printsCount
                      .filter(
                        ({ printFormatId, printPaperId }) =>
                          printFormatId === changePrint.printFormatId &&
                          printPaperId === changePrint.printPaperId,
                      )
                      .forEach(({ count }) => {
                        printsInPackage.push({
                          countInPackage: count,
                          addFileToPrintInPackage,
                          countInBasket: print.find(
                            (value) =>
                              value.printFormatId ===
                                changePrint.printFormatId &&
                              value.printPaperId === changePrint.printPaperId &&
                              value.printAndFileConfigId ===
                                printAndFileConfigId,
                          )
                            ? print
                                .filter(
                                  (value) =>
                                    value.printFormatId ===
                                      changePrint.printFormatId &&
                                    value.printPaperId ===
                                      changePrint.printPaperId &&
                                    value.printAndFileConfigId ===
                                      printAndFileConfigId,
                                )
                                .reduce((a, b) => a + b.count, 0)
                            : 0,
                          printFormatId: changePrint.printFormatId,
                          printPaperId: changePrint.printPaperId,
                          printAndFileConfigId,
                          packageInBasketId,
                          mode,
                        });
                      });
                  },
                );
            },
          );
        });
      }),
    );
    return { printsInPackage, packageInBasket, packagesInShop };
  }

  addPrintInPackageToBasket(
    printsInPackage: Array<PrintInPackage>,
    numberDifference: number,
    target: ChangeNumberComponent,
  ) {
    let countNumber = cloneDeep(numberDifference);
    const _printsInPackage =
      numberDifference > 0 ? printsInPackage : printsInPackage.reverse();
    _printsInPackage.forEach((print) => {
      if (countNumber !== 0 && print.mode !== 'PickedImage') {
        switch (print.mode) {
          case 'AnyImage':
            let currentNumber = 0;
            if (
              print.countInPackage - print.countInBasket > 0 &&
              countNumber > 0
            ) {
              if (print.countInPackage - print.countInBasket > countNumber) {
                currentNumber = countNumber;
                countNumber = 0;
              } else {
                currentNumber = print.countInPackage - print.countInBasket;
                countNumber -= print.countInPackage - print.countInBasket;
              }
            }
            if (print.countInBasket > 0 && countNumber < 0) {
              if (print.countInBasket > countNumber) {
                currentNumber = countNumber;
                countNumber = 0;
              } else {
                currentNumber = print.countInBasket;
                countNumber -= print.countInBasket;
              }
            }
            this.packagesInBasket$
              .pipe(first())
              .subscribe((packagesInBasket) => {
                const countPrintInPackageInBasket = packagesInBasket
                  .find(
                    ({ packageInBasketId }) =>
                      packageInBasketId === print.packageInBasketId,
                  )
                  .print?.find(
                    ({
                      printPaperId,
                      printFormatId,
                      printAndFileConfigId,
                      photoId,
                    }) =>
                      printPaperId === print.printPaperId &&
                      printFormatId === print.printFormatId &&
                      printAndFileConfigId === print.printAndFileConfigId &&
                      photoId === this._photoId,
                  );
                if (
                  currentNumber > 0 ||
                  (countPrintInPackageInBasket && currentNumber < 0)
                ) {
                  this.store.dispatch(
                    addPrintInPackageToBasketAction({
                      packageInBasketId: print.packageInBasketId,
                      print: {
                        printAndFileConfigId: print.printAndFileConfigId,
                        photoId: this._photoId,
                        printPaperId: print.printPaperId,
                        printFormatId: print.printFormatId,
                        count: currentNumber,
                      },
                    }),
                  );
                  if (print.addFileToPrintInPackage) {
                    const announcement =
                      this.autoAddFileToBasketTogetherWithPrintInPackageServiceService.autoAddFileToBasketTogetherWithPrint(
                        this._photoId,
                        print,
                      );
                    if (announcement) {
                      this.cd.detectChanges();
                      this.tooltipRef = null;
                      this.tooltipRef = this.tooltipService.open(
                        this.translationLoaderService.translate(
                          'productFront',
                          'clhoj0plt000008jz8zcz78au',
                        ),
                        'above',
                        this.windowFiles.find((v, index) => index === 0)
                          .nativeElement,
                      );
                      setTimeout(() => {
                        this.tooltipRef?.close();
                        this.tooltipRef = null;
                      }, 1000);
                    }
                  }
                }
              });
            break;
          case 'OneImage':
            this.packagesInShop$.pipe(first()).subscribe((packagesInShop) => {
              this.photoGroupsHasPhoto$
                .pipe(first())
                .subscribe((photoGroups) => {
                  this.packagesInBasket$
                    .pipe(first())
                    .subscribe((packagesInBasket) => {
                      const isAlreadyFile = packagesInBasket.find(
                        (packageInBasket) =>
                          packageInBasket.file.find(
                            (f) =>
                              f.photoId === this._photoId &&
                              packagesInShop.package.find(
                                ({ printAndFileConfig }) =>
                                  printAndFileConfig.find(
                                    ({ forcedImage }) =>
                                      forcedImage?.photoId === this._photoId,
                                  ),
                              ),
                          ) ||
                          packageInBasket.file.find(
                            (f) =>
                              f.photoId === this._photoId &&
                              packagesInShop.package.find(
                                ({ printAndFileConfig }) =>
                                  printAndFileConfig.find(
                                    ({ groups, mode }) =>
                                      mode === 'OneImage' &&
                                      groups.find(
                                        (group) =>
                                          group ===
                                          photoGroups.find(
                                            ({ photoId }) =>
                                              photoId === this._photoId,
                                          ).photoGroupId,
                                      ),
                                  ),
                              ),
                          ),
                      );
                      const printAndFileConf = packagesInShop.package
                        .find(({ printAndFileConfig }) =>
                          printAndFileConfig.find(
                            (y) =>
                              y.printAndFileConfigId ===
                              print.printAndFileConfigId,
                          ),
                        )
                        .printAndFileConfig.find(
                          (y) =>
                            y.printAndFileConfigId ===
                            print.printAndFileConfigId,
                        );
                      const addedToPackage = packagesInBasket.find(
                        (packageInBasket) =>
                          packageInBasket.packageInBasketId ===
                            print.packageInBasketId &&
                          packageInBasket.print.find(
                            (p) =>
                              p.printAndFileConfigId ===
                                print.printAndFileConfigId ||
                              packageInBasket.file.find(
                                (f) =>
                                  f.printAndFileConfigId ===
                                  print.printAndFileConfigId,
                              ),
                          ),
                      );
                      const prints = printAndFileConf.printsCount.map((p) => ({
                        count: p.count,
                        printFormatId: p.printFormatId,
                        printPaperId: p.printPaperId,
                        printAndFileConfigId: print.printAndFileConfigId,
                        photoId: this._photoId,
                      }));
                      const files = !isAlreadyFile
                        ? printAndFileConf.filesConfig.map(
                            ({ size, isFull }) => ({
                              isFull,
                              size,
                              printAndFileConfigId: print.printAndFileConfigId,
                              photoId: this._photoId,
                            }),
                          )
                        : [];
                      if (countNumber > 0 && !addedToPackage) {
                        const model = cloneDeep(
                          Object.entries(this.model.value),
                        );
                        if (
                          files.length &&
                          model.find(
                            (value) =>
                              value[0] === JSON.stringify(files[0].size),
                          )
                        ) {
                          model.find(
                            (value) =>
                              value[0] === JSON.stringify(files[0].size),
                          )[1] = true;
                          this.oldModel.old = model.reduce(
                            (obj, x) => ({
                              ...obj,
                              [x[0]]: x[1],
                            }),
                            {},
                          );
                          this.model.setValue(
                            model.reduce(
                              (obj, x) => ({
                                ...obj,
                                [x[0]]: x[1],
                              }),
                              {},
                            ),
                          );
                        }
                        this.store.dispatch(
                          addOneImageInPackageToBasketAction({
                            package: {
                              printAndFileConfigId: print.printAndFileConfigId,
                              packageInBasketId: print.packageInBasketId,
                              file: files,
                              print: prints,
                            },
                          }),
                        );
                        if (print.countInPackage >= countNumber) {
                          countNumber = 0;
                        } else {
                          countNumber -= print.countInPackage;
                        }
                      }
                      const countPrintInPackageInBasket = packagesInBasket
                        .find(
                          ({ packageInBasketId }) =>
                            packageInBasketId === print.packageInBasketId,
                        )
                        .print?.find(
                          ({
                            printPaperId,
                            printFormatId,
                            printAndFileConfigId,
                            photoId,
                          }) =>
                            printPaperId === print.printPaperId &&
                            printFormatId === print.printFormatId &&
                            printAndFileConfigId ===
                              print.printAndFileConfigId &&
                            photoId === this._photoId,
                        );
                      if (
                        countPrintInPackageInBasket &&
                        countNumber < 0 &&
                        addedToPackage
                      ) {
                        this.store.dispatch(
                          deleteFilesAndPrintsInPackageInBasketAction({
                            packageInBasketId: print.packageInBasketId,
                            photoId: this._photoId,
                            file: isAlreadyFile?.print.find(
                              ({ printAndFileConfigId, photoId }) =>
                                printAndFileConfigId !==
                                  print.printAndFileConfigId &&
                                photoId === this._photoId,
                            )
                              ? []
                              : isAlreadyFile?.file
                                  .filter(
                                    ({ photoId }) => photoId === this._photoId,
                                  )
                                  .map((f) => ({
                                    photoId: this._photoId,
                                    size: f.size,
                                    isFull: f.isFull,
                                    printAndFileConfigId:
                                      f.printAndFileConfigId,
                                  })),
                            print: prints,
                            printAndFileConfigId: print.printAndFileConfigId,
                          }),
                        );
                        if (print.countInBasket > countNumber) {
                          countNumber = 0;
                        } else {
                          countNumber -= print.countInPackage;
                        }
                      }
                    });
                });
            });
            break;
        }
      }
    });
    if (
      countNumber < 0 &&
      printsInPackage.find(
        (printInPackage) => printInPackage.mode === 'PickedImage',
      )
    ) {
      this.tooltipRef = this.tooltipService.open(
        this.translationLoaderService.translate(
          'productFront',
          'clhn8aott000109l908fq4ikd',
        ),
        'above',
        target.elementRef.nativeElement,
      );
      setTimeout(() => {
        this.tooltipRef?.close();
        this.tooltipRef = null;
      }, 1000);
    } else if (countNumber < 0 && this.addPrintFileToBasketIfNotAlreadyBought) {
      this.tooltipRef = this.tooltipService.open(
        this.translationLoaderService.translate(
          'productFront',
          'clhoj4l35000008mp86w80t9z',
        ),
        'above',
        target.elementRef.nativeElement,
      );
      setTimeout(() => {
        this.tooltipRef?.close();
        this.tooltipRef = null;
      }, 1000);
    }
    return numberDifference - (numberDifference - countNumber);
  }

  swapPhotoToProduct(selectedProductId) {
    this.isPhonePortrait$.pipe(first()).subscribe((isPhonePortrait) => {
      const swapPhoto = isPhonePortrait
        ? this.dialog.openFull(SwapPhotoInTheProductComponent, { isBare: true })
        : this.dialog.openFull(SwapPhotoInTheProductComponent);
      this.productsInBasket$.pipe(first()).subscribe((productsInBasket) => {
        swapPhoto.componentInstance.photosSelectedByPhotographer =
          productsInBasket.find(
            (p) => p.selectedProductId === selectedProductId,
          ).photoIdList;
      });
      swapPhoto.componentInstance.photoId = '';
      swapPhoto.componentInstance.swapPhoto
        .pipe(takeUntil(swapPhoto.afterClosed()))
        .subscribe((photoId) => {
          swapPhoto.close();
          this.store.dispatch(
            changePhotoToProductInBasket({
              product: {
                selectedProductId,
                oldPhotoId: photoId,
                newPhotoId: this._photoId,
              },
            }),
          );
          this.autoAddFileToBasketTogetherWithProductService.autoAddFileToBasketTogetherWithProduct();
        });
    });
  }

  addPrintWithoutPackage(
    target: ChangeNumberComponent,
    count: number,
    printFormatId: string,
    printPaperId: string,
  ) {
    combineLatest([
      this.visibleFiles$,
      this.visiblePrints$,
      this.priceToAddToEveryFileInProduct$,
      this.productsInBasket$,
      this.store.pipe(select(selectDoNotAddPriceOfFirstPrint)),
    ])
      .pipe(first())
      .subscribe(
        ([
          visibleFiles,
          visiblePrints,
          priceToAddToEveryFileInProduct,
          productsInBasket,
          doNotAddPriceOfFirstPrint,
        ]) => {
          const print = visiblePrints.find(
            (p) =>
              p.printPaperId === printPaperId &&
              p.printFormatId === printFormatId &&
              ((count < 0 && p.countInBasket > 0) || count > 0),
          );
          if (
            count !== 0 &&
            (!print || (!print.price.length && !print.inPackage))
          ) {
            this.tooltipRef = this.tooltipService.open(
              this.translationLoaderService.translate(
                'productFront',

                visiblePrints.find(
                  (p) =>
                    p.printPaperId === printPaperId &&
                    p.printFormatId === printFormatId,
                ).maxNumber >
                  visiblePrints.find(
                    (p) =>
                      p.printPaperId === printPaperId &&
                      p.printFormatId === printFormatId,
                  ).countInTogetherWithFile
                  ? 'clhojcidu000108jwcs2797a2'
                  : 'clhojcp73000208jw8exqcgyd',
              ),
              'above',
              target.elementRef.nativeElement,
            );
            setTimeout(() => {
              this.tooltipRef?.close();
              this.tooltipRef = null;
            }, 1000);
          } else if (
            count > 0 &&
            this.addPrintFileToBasketIfNotAlreadyBought &&
            !visibleFiles.find(({ inPackageOrInBasket }) => inPackageOrInBasket)
          ) {
            if (!doNotAddPriceOfFirstPrint) {
              this.store.dispatch(
                addPrintToBasket({
                  prints: {
                    count,
                    printId: cuid(),
                    printPaperId,
                    printFormatId,
                    photoId: this._photoId,
                  },
                }),
              );
            }
            const addFile = visibleFiles.length
              ? !!visibleFiles.find(({ isFull }) => !!isFull)
                ? {
                    ...visibleFiles.find(({ isFull }) => !!isFull),
                    index: visibleFiles.findIndex(({ isFull }) => !!isFull),
                  }
                : { ...visibleFiles[0], index: 0 }
              : {
                  isFull: true,
                  size: 0,
                  filePricingId: 'togetherWithPrint',
                  index: 0,
                };
            this.store.dispatch(
              addFileInBasketAction({
                file: {
                  photoId: this._photoId,
                  isFull: addFile.isFull,
                  togetherWithProduct: false,
                  togetherWithPrint: !doNotAddPriceOfFirstPrint,
                  size: addFile.size,
                  filePricingId: addFile.filePricingId,
                  retouchLevelId: 'standard',
                },
              }),
            );
            if (doNotAddPriceOfFirstPrint) {
              const printsIncluded = this.filesPricing.find(
                ({ size, isFull }) =>
                  size === addFile.size && isFull === addFile.isFull,
              )?.printsIncluded;
              let addedPrint = null;
              if (
                printsIncluded?.length &&
                (!priceToAddToEveryFileInProduct.addEveryFileToBasketIfNotAlreadyBought ||
                  (!productsInBasket.find(({ photoIdList }) =>
                    photoIdList.find(
                      ({ photoId }) => photoId === this._photoId,
                    ),
                  ) &&
                    !!priceToAddToEveryFileInProduct.addEveryFileToBasketIfNotAlreadyBought))
              ) {
                this.store.dispatch(
                  addPrintsListToBasketAction({
                    prints: printsIncluded.map((p) => ({
                      photoId: this._photoId,
                      printId: cuid(),
                      togetherWithFile: true,
                      count: p.count,
                      printFormatId: p.printFormatId,
                      printPaperId: p.printPaperId,
                    })),
                  }),
                );
                addedPrint = printsIncluded.find(
                  (p) =>
                    p.printFormatId === printFormatId &&
                    p.printPaperId === printPaperId,
                );
              }
              if (count - (addedPrint?.count || 0) > 0) {
                this.store.dispatch(
                  addPrintToBasket({
                    prints: {
                      count: count - (addedPrint?.count || 0),
                      printId: cuid(),
                      printPaperId,
                      printFormatId,
                      photoId: this._photoId,
                    },
                  }),
                );
              }
            }
            this.cd.detectChanges();
            this.tooltipRef = null;
            this.tooltipRef = this.tooltipService.open(
              this.translationLoaderService.translate(
                'productFront',
                'clhoj0plt000008jz8zcz78au',
              ),
              'above',
              this.windowFiles.find((v, index) => index === addFile.index)
                .nativeElement,
            );
            setTimeout(() => {
              this.tooltipRef?.close();
              this.tooltipRef = null;
            }, 1000);
          } else if (count > 0) {
            this.store.dispatch(
              addPrintToBasket({
                prints: {
                  count,
                  printPaperId,
                  printFormatId,
                  photoId: this._photoId,
                  printId: cuid(),
                },
              }),
            );
            return;
          } else if (
            count < 0 &&
            this.addPrintFileToBasketIfNotAlreadyBought &&
            visibleFiles.find(
              ({ togetherWithPrint, inPackage }) =>
                !!togetherWithPrint && !inPackage,
            )
          ) {
            this.visiblePrints$.pipe(first()).subscribe((visiblePrint) => {
              if (
                !visiblePrint.find(
                  (vP) =>
                    !(
                      vP.printFormatId === printFormatId &&
                      vP.printPaperId === printPaperId
                    ) && vP.countInBasket > 0,
                ) &&
                print.countInBasket + count <= print.minNumber
              ) {
                this.autoAddFileToBasketTogetherWithProductService.findDeletedFileInBasket(
                  this.photoId,
                  visibleFiles.find(({ inBasket }) => inBasket).filePricingId,
                  'print',
                );
              }
              this.store.dispatch(
                addPrintToBasket({
                  prints: {
                    count,
                    printPaperId,
                    printFormatId,
                    photoId: this._photoId,
                    printId: cuid(),
                  },
                }),
              );
            });
            return;
          } else if (count < 0) {
            this.visiblePrints$.pipe(first()).subscribe((visiblePrint) => {
              if (
                this.addPrintFileToBasketIfNotAlreadyBought &&
                !visiblePrint.find(
                  (vP) =>
                    !(
                      vP.printFormatId === printFormatId &&
                      vP.printPaperId === printPaperId
                    ) &&
                    (vP.countInBasket > 0 || vP.countInTogetherWithFile > 0),
                ) &&
                print.countInBasket + print.countInTogetherWithFile + count <=
                  print.minNumber - print.countInTogetherWithFile
              ) {
                this.autoAddFileToBasketTogetherWithProductService.findDeletedFileInBasket(
                  this.photoId,
                  visibleFiles.find(({ inBasket }) => inBasket)?.filePricingId,
                  'print',
                );
              }
              this.store.dispatch(
                addPrintToBasket({
                  prints: {
                    count,
                    printPaperId,
                    printFormatId,
                    photoId: this._photoId,
                    printId: cuid(),
                  },
                }),
              );
              return;
            });
          }
        },
      );
  }

  addPhotoToProductInPackage(selectedProductId: string) {
    this.productInPackageInBasket$.pipe(first()).subscribe((products) => {
      const product = products
        .find((x) =>
          x.products.find((y) => y.selectedProductId === selectedProductId),
        )
        .products.find((y) => y.selectedProductId === selectedProductId);
      this.store.dispatch(
        addProductInPackageToBasketAction({
          packageInBasketId: products.find((x) =>
            x.products.find((y) => y.selectedProductId === selectedProductId),
          ).packageInBasketId,
          product: {
            photos: [...product.photos, { photoId: this._photoId }],
            count: product.count,
            productId: product.productId,
            nameClientProduct: product.nameClientProduct,
            productInPackageId: product.productInPackageId,
            config: JSON.parse(product.config),
            selectedProductId,
            photosAddedByCustomer: true,
          },
        }),
      );
    });
  }

  removePhotoToProductInPackage(selectedProductId: string) {
    this.productInPackageInBasket$.pipe(first()).subscribe((products) => {
      const product = cloneDeep(
        products
          .find((x) =>
            x.products.find((y) => y.selectedProductId === selectedProductId),
          )
          .products.find((y) => y.selectedProductId === selectedProductId),
      );
      const photos = cloneDeep(product.photos);
      photos.splice(
        product.photos.findIndex(({ photoId }) => photoId === this._photoId),
        1,
      );
      this.store.dispatch(
        addProductInPackageToBasketAction({
          packageInBasketId: products.find((x) =>
            x.products.find((y) => y.selectedProductId === selectedProductId),
          ).packageInBasketId,
          product: {
            photos,
            count: product.count,
            productId: product.productId,
            nameClientProduct: product.nameClientProduct,
            productInPackageId: product.productInPackageId,
            config: JSON.parse(product.config),
            selectedProductId,
            photosAddedByCustomer: true,
          },
        }),
      );
    });
  }

  swapPhotoToProductInPackage(selectedProductId: string) {
    const swapPhoto = this.dialog.openFull(SwapPhotoInTheProductComponent);
    swapPhoto.componentInstance.photoId = '';
    this.productInPackageInBasket$.pipe(first()).subscribe((products) => {
      swapPhoto.componentInstance.photosSelectedByPhotographer = products
        .find((p) =>
          p.products.find((y) => y.selectedProductId === selectedProductId),
        )
        .products.find((y) => y.selectedProductId === selectedProductId).photos;
      swapPhoto.componentInstance.swapPhoto
        .pipe(takeUntil(swapPhoto.afterClosed()))
        .subscribe((photoId) => {
          swapPhoto.close();
          const product = cloneDeep(
            products
              .find((p) =>
                p.products.find(
                  (y) => y.selectedProductId === selectedProductId,
                ),
              )
              .products.find((y) => y.selectedProductId === selectedProductId),
          );
          const photos = cloneDeep(product.photos);
          photos.splice(
            product.photos.findIndex((p) => p.photoId === photoId),
            1,
          );
          photos.push({ photoId: this._photoId });
          this.store.dispatch(
            addProductInPackageToBasketAction({
              packageInBasketId: products.find((y) =>
                y.products.find(
                  (s) => s.selectedProductId === selectedProductId,
                ),
              ).packageInBasketId,
              product: {
                photos,
                count: product.count,
                productId: product.productId,
                nameClientProduct: product.nameClientProduct,
                productInPackageId: product.productInPackageId,
                config: JSON.parse(product.config),
                selectedProductId,
                photosAddedByCustomer: true,
              },
            }),
          );
        });
    });
  }

  showBasket() {
    import('../../../../../../../../public-session/src/app/public-session-basket-preview.module').then(
      (v) => {
        const injector = createInjector(
          v.PublicSessionBasketPreviewModule,
          this.injector,
        );
        const carouselModule = injector.get(v.PublicSessionBasketPreviewModule);
        const ref = this.dialog.openFull(carouselModule.getBasketView());
        this.isPhonePortrait$
          .pipe(takeUntil(ref.afterClosed()))
          .subscribe((isPhonePortrait) => {
            ref._containerInstance.isBare = isPhonePortrait;
          });
        ref.componentInstance.context = ZalamoObject.PublicSession;
        ref.componentInstance.closeDialog
          .pipe(takeUntil(ref.afterClosed()))
          .subscribe(() => ref.close());
        this.store
          .pipe(select(selectShoppingCartContext))
          .pipe(first())
          .subscribe(({ contextId }) => {
            ref.componentInstance.contextId = contextId;
          });
        this.deliveryMethods$.pipe(first()).subscribe((deliveryMethods) => {
          ref.componentInstance.deliveryMethods = deliveryMethods;
          ref.componentInstance.cd.detectChanges();
        });
        this.usePromoCodes$.pipe(first()).subscribe((usePromoCodes) => {
          ref.componentInstance.hasPromoCodes = usePromoCodes;
        });
        ref.componentInstance.closeDialog
          .pipe(takeUntil(ref.afterClosed()))
          .subscribe(() => ref.close());
        this.router.events.pipe(takeUntil(ref.afterClosed())).subscribe(() => {
          this.closeAllDialog.emit();
          ref.close();
        });
      },
    );
  }

  trackPrint(i) {
    return i;
  }

  trackFile(i) {
    return i;
  }
}
